import type { Variants } from '../types';

const metaDescriptionVariantTitles: Record<string, Variants> = {
	'/fr/film/after-2025': 'V1',
	'/fr/film/ballerina-2024': 'V2',
	'/fr/film/arco': 'V3',
	'/fr/film/apocalypse-now': 'V1',
	'/fr/film/amelie-et-la-metaphysique-des-tubes': 'V2',
	'/fr/film/blade-runner-2049': 'V3',
	'/fr/film/aftersun': 'V1',
	'/fr/film/blade-runner': 'V2',
	'/fr/film/argo': 'V3',
	'/fr/film/arrete-moi-si-tu-peux': 'V1',
	'/fr/film/28-semaines-plus-tard': 'V2',
	'/fr/film/a-couteaux-tires-2019': 'V3',
	'/fr/film/12-hommes-en-colere': 'V1',
	'/fr/film/best-in-show': 'V2',
	'/fr/film/a-knights-tale': 'V3',
	'/fr/film/american-psycho': 'V1',
	'/fr/film/before-sunrise': 'V2',
	'/fr/film/apollo-13': 'V3',
	'/fr/film/alien-romulus': 'V1',
	'/fr/film/anatomie-dune-chute': 'V2',
	'/fr/film/alien-le-8eme-passager': 'V3',
	'/fr/film/abigail-2024': 'V1',
	'/fr/film/bienvenue-a-gattaca': 'V2',
	'/fr/film/avant-toi': 'V3',
	'/fr/film/amadeus': 'V1',
	'/fr/film/babygirl-2024': 'V2',
	'/fr/film/a-friend-of-dorothy': 'V3',
	'/fr/film/10-bonnes-raisons-de-te-larguer': 'V1',
	'/fr/film/barry-lyndon': 'V2',
	'/fr/film/accused-2026': 'V3',
	'/fr/film/anyone-but-you': 'V1',
	'/fr/film/babylon-2022-0': 'V2',
	'/fr/film/alien-covenant': 'V3',
	'/fr/film/1917': 'V1',
	'/fr/film/500-jours-ensemble': 'V2',
	'/fr/film/american-history-x': 'V3',
	'/fr/film/a-bord-du-darjeeling-limited': 'V1',
	'/fr/film/avatar-2': 'V2',
	'/fr/film/akira': 'V3',
	'/fr/film/300': 'V1',
	'/fr/film/batman-begins': 'V2',
	'/fr/film/avatar': 'V3',
	'/fr/film/blackkklansman-jai-infiltre-le-ku-klux-klan': 'V1',
	'/fr/film/a-i-intelligence-artificielle': 'V2',
	'/fr/film/after-hours': 'V3',
	'/fr/film/a-beautiful-day-in-the-neighborhood': 'V1',
	'/fr/film/black-swan': 'V2',
	'/fr/film/a-big-bold-beautiful-journey': 'V3',
	'/fr/film/afterburn': 'V1',
	'/fr/film/american-pie': 'V2',
	'/fr/film/a-la-recherche-du-bonheur': 'V3',
	'/fr/film/a-bout-de-souffle': 'V1',
	'/fr/film/american-gangster': 'V2',
	'/fr/film/armageddon': 'V3',
	'/fr/film/ad-astra': 'V1',
	'/fr/film/aquaman-et-le-royaume-perdu': 'V2',
	'/fr/film/a-time-to-kill': 'V3',
	'/fr/film/a-quiet-place-day-one': 'V1',
	'/fr/film/avatar-a-new-era-special-edition-of-20-20': 'V2',
	'/fr/film/birdman': 'V3',
	'/fr/film/aliens-le-retour': 'V1',
	'/fr/film/beetlejuice-2-2025': 'V2',
	'/fr/film/blade': 'V3',
	'/fr/film/10-cloverfield-lane': 'V1',
	'/fr/film/a-man-called-otto': 'V2',
	'/fr/film/ben-hur': 'V3',
	'/fr/film/amateur-2024': 'V1',
	'/fr/film/a-la-poursuite-doctobre-rouge': 'V2',
	'/fr/film/banlieusards-3': 'V3',
	'/fr/film/a-real-pain': 'V1',
	'/fr/film/amar': 'V2',
	'/fr/film/21-jump-street': 'V3',
	'/fr/film/9-songs': 'V1',
	'/fr/film/12-years-a-slave': 'V2',
	'/fr/film/a-mon-seul-desir': 'V3',
	'/fr/film/asteroid-city': 'V1',
	'/fr/film/basic-instinct': 'V2',
	'/fr/film/20-days-in-mariupol': 'V3',
	'/fr/film/beignets-de-tomates-vertes': 'V1',
	'/fr/film/before-sunset': 'V2',
	'/fr/film/13-going-on-30': 'V3',
	'/fr/film/american-sniper': 'V1',
	'/fr/film/a-ghost-story': 'V2',
	'/fr/film/2-1': 'V3',
	'/fr/film/after-the-hunt': 'V1',
	'/fr/film/autant-en-emporte-le-vent-1939': 'V2',
	'/fr/film/adaptation-2002': 'V3',
	'/fr/film/all-quiet-on-the-western-front': 'V1',
	'/fr/film/air-2023': 'V2',
	'/fr/film/blood-diamond': 'V3',
	'/fr/film/afternoons-of-solitude': 'V1',
	'/fr/film/60-secondes-chrono': 'V2',
	'/fr/film/abyss': 'V3',
	'/fr/film/27-robes': 'V1',
	'/fr/film/anges-et-demons': 'V2',
	'/fr/film/american-girls': 'V3',
	'/fr/film/barry-seal-american-traffic': 'V1',
	'/fr/film/anna-2019': 'V2',
	'/fr/film/13-hours': 'V3',
	'/fr/film/57-seconds': 'V1',
	'/fr/film/battle-royale': 'V2',
	'/fr/film/baby-boss': 'V3',
	'/fr/film/a-toute-epreuve-1992': 'V1',
	'/fr/film/anaconda': 'V2',
	'/fr/film/a-beautiful-day': 'V3',
	'/fr/film/365-dni': 'V1',
	'/fr/film/au-dela-de-nos-reves': 'V2',
	'/fr/film/after-midnight-2019': 'V3',
	'/fr/film/allies-2016': 'V1',
	'/fr/film/1984': 'V2',
	'/fr/film/as-good-as-it-gets': 'V3',
	'/fr/film/below': 'V1',
	'/fr/film/blackberry': 'V2',
	'/fr/film/30-minutes-maximum': 'V3',
	'/fr/film/all-the-empty-rooms': 'V1',
	'/fr/film/alita-battle-angel': 'V2',
	'/fr/film/before-midnight': 'V3',
	'/fr/film/arizona-junior': 'V1',
	'/fr/film/agents-tres-speciaux-code-u-n-c-l-e': 'V2',
	'/fr/film/alone-2020': 'V3',
	'/fr/film/4-mariages-and-1-enterrement': 'V1',
	'/fr/film/ave-cesar': 'V2',
	'/fr/film/assurance-sur-la-mort': 'V3',
	'/fr/film/25th-hour': 'V1',
	'/fr/film/anemone': 'V2',
	'/fr/film/awake': 'V3',
	'/fr/film/american-kamasutra': 'V1',
	'/fr/film/22-jump-street': 'V2',
	'/fr/film/2000-meters-to-andriivka': 'V3',
	'/fr/film/american-ultra-2015': 'V1',
	'/fr/film/after-chapitre-i': 'V2',
	'/fr/film/ace-ventura-en-afrique': 'V3',
	'/fr/film/50-50': 'V1',
	'/fr/film/billy-elliot': 'V2',
	'/fr/film/babe-le-cochon-devenu-berger': 'V3',
	'/fr/film/7-psychopathes': 'V1',
	'/fr/film/avengers-4': 'V2',
	'/fr/film/21-and-over': 'V3',
	'/fr/film/20-ans-decart': 'V1',
	'/fr/film/a-serious-man': 'V2',
	'/fr/film/an-honest-liar': 'V3',
	'/fr/film/adopt-a-highway': 'V1',
	'/fr/film/belles-a-mourir': 'V2',
	'/fr/film/argylle': 'V3',
	'/fr/film/americana': 'V1',
	'/fr/film/apparences': 'V2',
	'/fr/film/american-bluff': 'V3',
	'/fr/film/belen': 'V1',
	'/fr/film/big': 'V2',
	'/fr/film/albert-a-louest': 'V3',
	'/fr/film/austin-powers-lespion-qui-ma-tiree': 'V1',
	'/fr/film/american-pie-2': 'V2',
	'/fr/film/au-bout-de-la-nuit': 'V3',
	'/fr/film/alien-vs-predator': 'V1',
	'/fr/film/badak': 'V2',
	'/fr/film/avengers': 'V3',
	'/fr/film/bacurau': 'V1',
	'/fr/film/amours-chiennes': 'V2',
	'/fr/film/austin-powers-dans-goldmember': 'V3',
	'/fr/film/65': 'V1',
	'/fr/film/any-given-sunday': 'V2',
	'/fr/film/barefoot': 'V3',
	'/fr/film/127-heures': 'V1',
	'/fr/film/2-fast-2-furious': 'V2',
	'/fr/film/alice-darling': 'V3',
	'/fr/film/audition': 'V1',
	'/fr/film/a-different-man': 'V2',
	'/fr/film/black-and-white-and-sex': 'V3',
	'/fr/film/17-ans-encore': 'V1',
	'/fr/film/32nd-annual-actor-awards': 'V2',
	'/fr/film/40-ans-mode-demploi': 'V3',
	'/fr/film/28-days': 'V1',
	'/fr/film/beyond-disclosure-the-corey-goode-files': 'V2',
	'/fr/film/across-the-universe': 'V3',
	'/fr/film/back-to-black': 'V1',
	'/fr/film/bad-boys-ii': 'V2',
	'/fr/film/a-haunting-in-venice': 'V3',
	'/fr/film/amour': 'V1',
	'/fr/film/batman-v-superman-laube-de-la-justice': 'V2',
	'/fr/film/bedazzled': 'V3',
	'/fr/film/30-jours-de-nuit': 'V1',
	'/fr/film/barton-fink': 'V2',
	'/fr/film/beaucoup-de-bruit-pour-rien-1993': 'V3',
	'/fr/film/48-heures': 'V1',
	'/fr/film/absolutely-anything': 'V2',
	'/fr/film/300-la-naissance-dun-empire': 'V3',
	'/fr/film/a-la-poursuite-de-demain': 'V1',
	'/fr/film/a-tout-jamais-une-histoire-de-cendrillon': 'V2',
	'/fr/film/beethoven': 'V3',
	'/fr/film/aquaman': 'V1',
	'/fr/film/amoureuse-a-noel': 'V2',
	'/fr/film/animal-kingdom': 'V3',
	'/fr/film/american-nightmare': 'V1',
	'/fr/film/american-animals': 'V2',
	'/fr/film/alexandre': 'V3',
	'/fr/film/annie': 'V1',
	'/fr/film/alpha-2025-1': 'V2',
	'/fr/film/bend-it-like-beckham': 'V3',
	'/fr/film/anna-karenine-2012': 'V1',
	'/fr/film/becky': 'V2',
	'/fr/film/black-rain': 'V3',
	'/fr/film/barbara-becoming-shirin-david': 'V1',
	'/fr/film/alien-3': 'V2',
	'/fr/film/belfast': 'V3',
	'/fr/film/anastasia': 'V1',
	'/fr/film/arlington-road': 'V2',
	'/fr/film/blade-ii': 'V3',
	'/fr/film/birds-of-prey-et-la-fantabuleuse-histoire-de-harley-quinn': 'V1',
	'/fr/film/american-graffiti': 'V2',
	'/fr/film/batman-le-defi': 'V3',
	'/fr/film/american-sweatshop': 'V1',
	'/fr/film/a-nous-quatre': 'V2',
	'/fr/film/all-about-my-mother': 'V3',
	'/fr/film/2010-lannee-du-premier-contact': 'V1',
	'/fr/film/black-panther': 'V2',
	'/fr/film/au-revoir-a-jamais': 'V3',
	'/fr/film/billy-madison': 'V1',
	'/fr/film/amistad': 'V2',
	'/fr/film/bienvenue-mister-chance': 'V3',
	'/fr/film/7-vierges': 'V1',
	'/fr/film/along-came-polly': 'V2',
	'/fr/film/black-adam': 'V3',
	'/fr/film/big-daddy': 'V1',
	'/fr/film/a-couteaux-tires': 'V2',
	'/fr/film/ash': 'V3',
	'/fr/film/against-all-odds': 'V1',
	'/fr/film/big-bad-wolves': 'V2',
	'/fr/film/air-force-one': 'V3',
	'/fr/film/au-dela': 'V1',
	'/fr/film/ambulance': 'V2',
	'/fr/film/a-scanner-darkly': 'V3',
	'/fr/film/birth-2004': 'V1',
	'/fr/film/amber-alert': 'V2',
	'/fr/film/backdraft': 'V3',
	'/fr/film/anger-management': 'V1',
	'/fr/film/animatrix': 'V2',
	'/fr/film/a-girl-walks-home-alone-at-night': 'V3',
	'/fr/film/aux-coeurs-des-tenebres-lapocalypse-dun-metteur-en-scene': 'V1',
	'/fr/film/20th-century-women': 'V2',
	'/fr/film/admis-a-tout-prix': 'V3',
	'/fr/film/a-feu-doux': 'V1',
	'/fr/film/big-movie': 'V2',
	'/fr/film/about-a-boy': 'V3',
	'/fr/film/a-laveugle': 'V1',
	'/fr/film/angry-birds-copains-comme-cochons': 'V2',
	'/fr/film/arthur-the-king': 'V3',
	'/fr/film/balade-entre-les-tombes': 'V1',
	'/fr/film/avengers-lere-dultron': 'V2',
	'/fr/film/a-louest-rien-de-nouveau': 'V3',
	'/fr/film/a-contre-sens-londres': 'V1',
	'/fr/film/american-honey': 'V2',
	'/fr/film/black-widow-2020': 'V3',
	'/fr/film/5-centimetres-par-seconde': 'V1',
	'/fr/film/a-tale-of-two-sisters': 'V2',
	'/fr/film/arctic': 'V3',
	'/fr/film/and-justice-for-all': 'V1',
	'/fr/film/a-vif': 'V2',
	'/fr/film/a-bigger-splash': 'V3',
	'/fr/film/bird-2024': 'V1',
	'/fr/film/bird-box': 'V2',
	'/fr/film/before-i-fall': 'V3',
	'/fr/film/balto-chien-loup-heros-des-neiges': 'V1',
	'/fr/film/aquarius': 'V2',
	'/fr/film/blade-runner-the-final-cut': 'V3',
	'/fr/film/aguirre-la-colere-de-dieu': 'V1',
	'/fr/film/a-la-recherche-de-bobby-fischer': 'V2',
	'/fr/film/beaute-cachee': 'V3',
	'/fr/film/beyond-the-infinite-two-minutes': 'V1',
	'/fr/film/baywatch-alerte-a-malibu': 'V2',
	'/fr/film/au-coeur-de-locean': 'V3',
	'/fr/film/appel-durgence': 'V1',
	'/fr/film/bilbo-le-hobbit': 'V2',
	'/fr/film/american-underdog': 'V3',
	'/fr/film/baskin': 'V1',
	'/fr/film/2-guns': 'V2',
	'/fr/film/aliens-vs-predator-requiem': 'V3',
	'/fr/film/bad-teacher': 'V1',
	'/fr/film/bastille-day': 'V2',
	'/fr/film/believe-me-enlevee-par-un-tueur': 'V3',
	'/fr/film/analyze-this': 'V1',
	'/fr/film/au-dela-du-reel': 'V2',
	'/fr/film/blackfish': 'V3',
	'/fr/film/ali-g-indahouse': 'V1',
	'/fr/film/american-pie-4': 'V2',
	'/fr/film/babysitter-wanted': 'V3',
	'/fr/film/black-panther-ii': 'V1',
	'/fr/film/a-la-belle-etoile-2023-0': 'V2',
	'/fr/film/a-contre-sens-2': 'V3',
	'/fr/film/an-ensemble-for-the-ages': 'V1',
	'/fr/film/autopsie-dun-meurtre': 'V2',
	'/fr/film/a-simple-favor-2': 'V3',
	'/fr/film/a-million-miles-away': 'V1',
	'/fr/film/42': 'V2',
	'/fr/film/barbarella': 'V3',
	'/fr/film/anatomie-dun-top-model': 'V1',
	'/fr/film/24-hour-party-people': 'V2',
	'/fr/film/an-american-pickle': 'V3',
	'/fr/film/berlin-calling': 'V1',
	'/fr/film/bernadette-a-disparu': 'V2',
	'/fr/film/3-days-to-kill': 'V3',
	'/fr/film/bienvenue-a-suburbicon': 'V1',
	'/fr/film/beautiful-disaster': 'V2',
	'/fr/film/a-la-croisee-des-mondes-la-boussole-dor': 'V3',
	'/fr/film/annie-2014': 'V1',
	'/fr/film/anomalisa': 'V2',
	'/fr/film/bad-moms': 'V3',
	'/fr/film/assassins-creed': 'V1',
	'/fr/film/backcountry': 'V2',
	'/fr/film/antebellum': 'V3',
	'/fr/film/andrei-roublev': 'V1',
	'/fr/film/ant-man': 'V2',
	'/fr/film/assaut': 'V3',
	'/fr/film/7-jours-et-une-vie': 'V1',
	'/fr/film/ballerina': 'V2',
	'/fr/film/after-chapitre-2': 'V3',
	'/fr/film/bienvenue-chez-les-chtis': 'V1',
	'/fr/film/a-linterieur-2007': 'V2',
	'/fr/film/big-trouble-2002': 'V3',
	'/fr/film/annabelle': 'V1',
	'/fr/film/alex-cross': 'V2',
	'/fr/film/army-of-shadows': 'V3',
	'/fr/film/blair-witch': 'V1',
	'/fr/film/american-movie': 'V2',
	'/fr/film/12th-fail': 'V3',
	'/fr/film/black-dynamite': 'V1',
	'/fr/film/arsenic-et-vieilles-dentelles': 'V2',
	'/fr/film/april-29-1992': 'V3',
	'/fr/film/blood-and-bone': 'V1',
	'/fr/film/100-metres': 'V2',
	'/fr/film/azrael': 'V3',
	'/fr/film/alice-nest-plus-ici': 'V1',
	'/fr/film/aladdin': 'V2',
	'/fr/film/a-useful-ghost': 'V3',
	'/fr/film/automata': 'V1',
	'/fr/film/apocalypse-z-le-debut-de-la-fin': 'V2',
	'/fr/film/96-minutes': 'V3',
	'/fr/film/au-service-secret-de-sa-majeste': 'V1',
	'/fr/film/black-dog-2024': 'V2',
	'/fr/film/agora': 'V3',
	'/fr/film/awareness': 'V1',
	'/fr/film/american-college': 'V2',
	'/fr/film/adams-apples': 'V3',
	'/fr/film/adventureland-un-job-dete-a-eviter': 'V1',
	'/fr/film/alvin-et-les-chipmunks': 'V2',
	'/fr/film/after-yang': 'V3',
	'/fr/film/aeon-flux': 'V1',
	'/fr/film/blade-trinity': 'V2',
	'/fr/film/before-we-go': 'V3',
	'/fr/film/army-of-the-dead-2021': 'V1',
	'/fr/film/atlantide-lempire-perdu': 'V2',
	'/fr/film/ant-man-et-la-guepe': 'V3',
	'/fr/film/alpha-dog': 'V1',
	'/fr/film/2046': 'V2',
	'/fr/film/a-street-cat-named-bob': 'V3',
	'/fr/film/andre-is-an-idiot': 'V1',
	'/fr/film/bean': 'V2',
	'/fr/film/avengement': 'V3',
	'/fr/film/a-most-violent-year': 'V1',
	'/fr/film/aladdin-2019': 'V2',
	'/fr/film/blood-island': 'V3',
	'/fr/film/blanche-neige-2019': 'V1',
	'/fr/film/13-assassins': 'V2',
	'/fr/film/australia': 'V3',
	'/fr/film/20-000-species-of-bees': 'V1',
	'/fr/film/badh-2025': 'V2',
	'/fr/film/black-book': 'V3',
	'/fr/film/absolute-power': 'V1',
	'/fr/film/blood-and-bones-2017': 'V2',
	'/fr/film/amazons': 'V3',
	'/fr/film/away': 'V1',
	'/fr/film/black-47': 'V2',
	'/fr/film/another-earth': 'V3',
	'/fr/film/always': 'V1',
	'/fr/film/au-nom-des-femmes-le-combat-de-judy-wood': 'V2',
	'/fr/film/a-better-man': 'V3',
	'/fr/film/1941': 'V1',
	'/fr/film/88-minutes': 'V2',
	'/fr/film/a-la-derive': 'V3',
	'/fr/film/aujourdhui-est-un-autre-jour': 'V1',
	'/fr/film/baseketball': 'V2',
	'/fr/film/beau-travail': 'V3',
	'/fr/film/alice-au-pays-des-merveilles': 'V1',
	'/fr/film/22-miles': 'V2',
	'/fr/film/alamo': 'V3',
	'/fr/film/a-tous-les-garcons-que-jai-aimes': 'V1',
	'/fr/film/after-everything-2023': 'V2',
	'/fr/film/bande-de-sauvages': 'V3',
	'/fr/film/amarcord': 'V1',
	'/fr/film/babes': 'V2',
	'/fr/film/belle-2021': 'V3',
	'/fr/film/beyond-the-sea': 'V1',
	'/fr/film/after-chapitre-4': 'V2',
	'/fr/film/anaganaga-oka-raju': 'V3',
	'/fr/film/blonde': 'V1',
	'/fr/film/belly': 'V2',
	'/fr/film/anaconda-2024': 'V3',
	'/fr/film/arthur-et-les-minimoys': 'V1',
	'/fr/film/71': 'V2',
	'/fr/film/arthur-1981': 'V3',
	'/fr/film/batman-mask-of-the-phantasm': 'V1',
	'/fr/film/airborne-2012': 'V2',
	'/fr/film/adieu-ma-concubine': 'V3',
	'/fr/film/at-close-range': 'V1',
	'/fr/film/a-desert': 'V2',
	'/fr/film/ballroom-dancing': 'V3',
	'/fr/film/7-ans-de-seduction': 'V1',
	'/fr/film/abraham-lincoln-chasseur-de-vampires': 'V2',
	'/fr/film/arnaque-a-la-carte': 'V3',
	'/fr/film/airport': 'V1',
	'/fr/film/american-trip': 'V2',
	'/fr/film/armand': 'V3',
	'/fr/film/alcarras': 'V1',
	'/fr/film/ant-man-3': 'V2',
	'/fr/film/48-heures-de-plus': 'V3',
	'/fr/film/better-days': 'V1',
	'/fr/film/adventures-in-babysitting': 'V2',
	'/fr/film/avanti': 'V3',
	'/fr/film/beaches': 'V1',
	'/fr/film/bebe-mode-demploi': 'V2',
	'/fr/film/appaloosa': 'V3',
	'/fr/film/american-girls-3': 'V1',
	'/fr/film/assassination-tango': 'V2',
	'/fr/film/ali': 'V3',
	'/fr/film/birth-rebirth': 'V1',
	'/fr/film/bitter-moon': 'V2',
	'/fr/film/bernie-2012': 'V3',
	'/fr/film/5-flights-up': 'V1',
	'/fr/film/as-good-as-dead': 'V2',
	'/fr/film/all-is-true': 'V3',
	'/fr/film/antlers': 'V1',
	'/fr/film/attache-moi': 'V2',
	'/fr/film/battle-of-the-sexes': 'V3',
	'/fr/film/a-ceux-qui-nous-ont-offenses': 'V1',
	'/fr/film/big-eyes': 'V2',
	'/fr/film/asterix-and-obelix-take-on-caesar': 'V3',
	'/fr/film/action-ou-verite-2018': 'V1',
	'/fr/film/20-feet-from-stardom': 'V2',
	'/fr/film/balles-de-feu': 'V3',
	'/fr/film/a-perfect-ending': 'V1',
	'/fr/film/after-earth': 'V2',
	'/fr/film/annabelle-la-maison-du-mal': 'V3',
	'/fr/film/99-moons': 'V1',
	'/fr/film/a-travers-ma-fenetre': 'V2',
	'/fr/film/arkansas': 'V3',
	'/fr/film/3-femmes': 'V1',
	'/fr/film/all-eyez-on-me': 'V2',
	'/fr/film/after-life-1998': 'V3',
	'/fr/film/alpeis': 'V1',
	'/fr/film/blanche-neige-et-les-sept-nains': 'V2',
	'/fr/film/alive-2020': 'V3',
	'/fr/film/2067': 'V1',
	'/fr/film/a-nous-la-victoire': 'V2',
	'/fr/film/a-dogs-journey': 'V3',
	'/fr/film/betray': 'V1',
	'/fr/film/aux-yeux-de-tous-2015': 'V2',
	'/fr/film/a-very-long-engagement': 'V3',
	'/fr/film/bandits': 'V1',
	'/fr/film/bienvenue-chez-les-robinson': 'V2',
	'/fr/film/benjamin-gates-et-le-livre-des-secrets': 'V3',
	'/fr/film/another-year': 'V1',
	'/fr/film/american-mary': 'V2',
	'/fr/film/before-i-wake': 'V3',
	'/fr/film/assassins': 'V1',
	'/fr/film/bienvenue-dans-la-jungle': 'V2',
	'/fr/film/alarme-fatale': 'V3',
	'/fr/film/american-nightmare-3-elections': 'V1',
	'/fr/film/american-pie-presents-band-camp': 'V2',
	'/fr/film/an-american-crime': 'V3',
	'/fr/film/anything-for-jackson': 'V1',
	'/fr/film/apartment-7a': 'V2',
	'/fr/film/beginners': 'V3',
	'/fr/film/black-death': 'V1',
	'/fr/film/amityville-la-maison-du-diable': 'V2',
	'/fr/film/10-000': 'V3',
	'/fr/film/1br': 'V1',
	'/fr/film/37deg2-le-matin': 'V2',
	'/fr/film/2001-maniacs': 'V3',
	'/fr/film/batman-under-the-red-hood': 'V1',
	'/fr/film/basquiat': 'V2',
	'/fr/film/1492-christophe-colomb': 'V3',
	'/fr/film/blindspotting': 'V1',
	'/fr/film/anacondas-the-hunt-for-the-blood-orchid': 'V2',
	'/fr/film/beyond-utopia': 'V3',
	'/fr/film/blindness': 'V1',
	'/fr/film/a-midsummer-nights-dream': 'V2',
	'/fr/film/4-mois-3-semaines-2-jours': 'V3',
	'/fr/film/2019-5': 'V1',
	'/fr/film/amour-a-la-derive': 'V2',
	'/fr/film/around-the-world-in-80-days': 'V3',
	'/fr/film/blanche-neige': 'V1',
	'/fr/film/after-chapitre-3': 'V2',
	'/fr/film/black-snake-moan': 'V3',
	'/fr/film/bad-lieutenant-escale-a-la-nouvelle-orleans': 'V1',
	'/fr/film/anna-and-the-apocalypse': 'V2',
	'/fr/film/american-nightmare-2-anarchy': 'V3',
	'/fr/film/arnaqueurs-associes': 'V1',
	'/fr/film/best-sellers': 'V2',
	'/fr/film/bad-words': 'V3',
	'/fr/film/american-me': 'V1',
	'/fr/film/666-road': 'V2',
	'/fr/film/47-meters-down': 'V3',
	'/fr/film/alabama-monroe': 'V1',
	'/fr/film/appelez-moi-dave': 'V2',
	'/fr/film/apparitions': 'V3',
	'/fr/film/attack-on-titan-the-movie-the-last-attack': 'V1',
	'/fr/film/baise-moi': 'V2',
	'/fr/film/american-pie-campus-en-folie': 'V3',
	'/fr/film/alphaville': 'V1',
	'/fr/film/beat-battle': 'V2',
	'/fr/film/american-pie-string-academy': 'V3',
	'/fr/film/benny-and-joon': 'V1',
	'/fr/film/biutiful': 'V2',
	'/fr/film/ben-hur-2016': 'V3',
	'/fr/film/black-christmas': 'V1',
	'/fr/film/99-homes': 'V2',
	'/fr/film/asterix-le-secret-de-la-potion-magique': 'V3',
	'/fr/film/all-about-albert': 'V1',
	'/fr/film/blitz-2024': 'V2',
	'/fr/film/1922': 'V3',
	'/fr/film/beasts-of-no-nation': 'V1',
	'/fr/film/blink-2024': 'V2',
	'/fr/film/bad-news-bears': 'V3',
	'/fr/film/beaute-volee': 'V1',
	'/fr/film/babys-day-out': 'V2',
	'/fr/film/bad-boy-bubby': 'V3',
	'/fr/film/84-charing-cross-road': 'V1',
	'/fr/film/amore': 'V2',
	'/fr/film/all-eyes-off-me': 'V3',
	'/fr/film/apocalypse-in-the-tropics': 'V1',
	'/fr/film/arn-chevalier-du-temple': 'V2',
	'/fr/film/action-ou-verite': 'V3',
	'/fr/film/apollo-18': 'V1',
	'/fr/film/banlieusards': 'V2',
	'/fr/film/amours-irlandaises': 'V3',
	'/fr/film/baby-sitter-malgre-lui': 'V1',
	'/fr/film/all-hallows-eve-2013': 'V2',
	'/fr/film/alice-de-lautre-cote-du-miroir': 'V3',
	'/fr/film/16-blocs': 'V1',
	'/fr/film/bienvenue-a-monte-carlo': 'V2',
	'/fr/film/agent-double': 'V3',
	'/fr/film/animale': 'V1',
	'/fr/film/a-case-history': 'V2',
	'/fr/film/atlas-2024': 'V3',
	'/fr/film/baby-mama': 'V1',
	'/fr/film/alvin-et-les-chipmunks-3': 'V2',
	'/fr/film/adolescence-explosive': 'V3',
	'/fr/film/back-to-school': 'V1',
	'/fr/film/aux-portes-de-lau-dela': 'V2',
	'/fr/film/au-premier-regard': 'V3',
	'/fr/film/a-la-recherche-de-mr-goodbar': 'V1',
	'/fr/film/black-mirror-bandersnatch': 'V2',
	'/fr/film/13-sins': 'V3',
	'/fr/film/beirut': 'V1',
	'/fr/film/au-revoir-les-enfants': 'V2',
	'/fr/film/agra-une-famille-indienne': 'V3',
	'/fr/film/blitz': 'V1',
	'/fr/film/baby-2025-0': 'V2',
	'/fr/film/air-bud-buddy-star-des-paniers': 'V3',
	'/fr/film/a-thousand-and-one-2023': 'V1',
	'/fr/film/a-field-in-england': 'V2',
	'/fr/film/bad-dreams': 'V3',
	'/fr/film/american-boy': 'V1',
	'/fr/film/amer-beton': 'V2',
	'/fr/film/before-night-falls': 'V3',
	'/fr/film/american-splendor': 'V1',
	'/fr/film/2-coeurs': 'V2',
	'/fr/film/anonymous': 'V3',
	'/fr/film/a-call-to-spy': 'V1',
	'/fr/film/amityville': 'V2',
	'/fr/film/blame-it-on-rio': 'V3',
	'/fr/film/119-jours-les-survivants-de-locean': 'V1',
	'/fr/film/attraction-2': 'V2',
	'/fr/film/being-john-smith': 'V3',
	'/fr/film/beautiful-wedding': 'V1',
	'/fr/film/andhadhun': 'V2',
	'/fr/film/aquamarine': 'V3',
	'/fr/film/adventures-of-the-naked-umbrella': 'V1',
	'/fr/film/10dance': 'V2',
	'/fr/film/anon': 'V3',
	'/fr/film/a-goofy-movie': 'V1',
	'/fr/film/agent-cody-banks': 'V2',
	'/fr/film/always-be-my-maybe': 'V3',
	'/fr/film/40-days-and-40-nights': 'V1',
	'/fr/film/baby-boy': 'V2',
	'/fr/film/ask-me-anything': 'V3',
	'/fr/film/a-teacher': 'V1',
	'/fr/film/a-fleur-de-peau': 'V2',
	'/fr/film/a-propos-delly': 'V3',
	'/fr/film/asterix-and-obelix-the-middle-kingdom': 'V1',
	'/fr/film/anunnaki': 'V2',
	'/fr/film/berlin-nobody': 'V3',
	'/fr/film/bad-education': 'V1',
	'/fr/film/autumn-in-new-york': 'V2',
	'/fr/film/9-ways-to-hell': 'V3',
	'/fr/film/asterix-aux-jeux-olympiques': 'V1',
	'/fr/film/babe-pig-in-the-city-1998': 'V2',
	'/fr/film/animal-2022': 'V3',
	'/fr/film/armored-2024': 'V1',
	'/fr/film/bird-box-barcelona': 'V2',
	'/fr/film/atlantique-latitude-41deg': 'V3',
	'/fr/film/black-storm': 'V1',
	'/fr/film/all-my-friends-hate-me': 'V2',
	'/fr/film/angelas-ashes': 'V3',
	'/fr/film/1984-1956': 'V1',
	'/fr/film/addicted': 'V2',
	'/fr/film/best-of-the-best': 'V3',
	'/fr/film/alarum': 'V1',
	'/fr/film/batman-the-dark-knight-returns-part-1': 'V2',
	'/fr/film/basic-instinct-2': 'V3',
	'/fr/film/be-happy': 'V1',
	'/fr/film/batman-vs-teenage-mutant-ninja-turtles': 'V2',
	'/fr/film/art-of-the-steal': 'V3',
	'/fr/film/bio-dome': 'V1',
	'/fr/film/barbaque': 'V2',
	'/fr/film/bird-on-a-wire': 'V3',
	'/fr/film/american-pie-les-sex-commandements': 'V1',
	'/fr/film/5-ans-de-reflexion': 'V2',
	'/fr/film/black-and-blue': 'V3',
	'/fr/film/11-rebels': 'V1',
	'/fr/film/akeelah': 'V2',
	'/fr/film/assault-on-precinct-13': 'V3',
	'/fr/film/big-boss': 'V1',
	'/fr/film/benvenuti-al-sud': 'V2',
	'/fr/film/baby-assassins': 'V3',
	'/fr/film/batman-hush': 'V1',
	'/fr/film/a-perfect-day-un-jour-comme-un-autre': 'V2',
	'/fr/film/battlestar-galactica-the-plan': 'V3',
	'/fr/film/a-family-affair-2023': 'V1',
	'/fr/film/aashiqui-2': 'V2',
	'/fr/film/acts-of-violence': 'V3',
	'/fr/film/antartica-prisonniers-du-froid': 'V1',
	'/fr/film/a-long-way-from-nowhere': 'V2',
	'/fr/film/astro-boy': 'V3',
	'/fr/film/asterix-chez-les-bretons': 'V1',
	'/fr/film/annette-2021': 'V2',
	'/fr/film/beowulf-la-legende-viking': 'V3',
	'/fr/film/american-carnage': 'V1',
	'/fr/film/blanches-colombes-et-vilains-messieurs': 'V2',
	'/fr/film/ay-carmela': 'V3',
	'/fr/film/bachelorette': 'V1',
	'/fr/film/an-elephant-sitting-still': 'V2',
	'/fr/film/a-la-merveille': 'V3',
	'/fr/film/47-meters-down-uncaged': 'V1',
	'/fr/film/10': 'V2',
	'/fr/film/akhanda-2': 'V3',
	'/fr/film/another-you-2025': 'V1',
	'/fr/film/along-with-the-gods-the-last-49-days': 'V2',
	'/fr/film/a-summers-tale': 'V3',
	'/fr/film/blessed-boys': 'V1',
	'/fr/film/agents-super-zero-2014': 'V2',
	'/fr/film/black-butterfly': 'V3',
	'/fr/film/black-water': 'V1',
	'/fr/film/barbarian-queen': 'V2',
	'/fr/film/a-normal-family': 'V3',
	'/fr/film/arq': 'V1',
	'/fr/film/au-hasard-balthazar': 'V2',
	'/fr/film/ben-is-back': 'V3',
	'/fr/film/barb-wire': 'V1',
	'/fr/film/baby-bluff': 'V2',
	'/fr/film/americas-sweethearts': 'V3',
	'/fr/film/belle-epoque': 'V1',
	'/fr/film/bird': 'V2',
	'/fr/film/barbie-as-the-princess-and-the-pauper': 'V3',
	'/fr/film/absence-of-malice': 'V1',
	'/fr/film/3h10-pour-yuma': 'V2',
	'/fr/film/a-dogs-way-home': 'V3',
	'/fr/film/almost-heroes': 'V1',
	'/fr/film/a-good-marriage': 'V2',
	'/fr/film/barbe-dor-et-les-pirates': 'V3',
	'/fr/film/barbara': 'V1',
	'/fr/film/barking-dog': 'V2',
	'/fr/film/benni': 'V3',
	'/fr/film/baby-assassins-nice-days': 'V1',
	'/fr/film/alan-partridge-alpha-papa': 'V2',
	'/fr/film/aftermath': 'V3',
	'/fr/film/barbie-fairytopia': 'V1',
	'/fr/film/au-bout-du-tunnel': 'V2',
	'/fr/film/barfly': 'V3',
	'/fr/film/about-endlessness': 'V1',
	'/fr/film/alibi-com-2017': 'V2',
	'/fr/film/allo-maman-cest-encore-moi': 'V3',
	'/fr/film/addicted-to-love': 'V1',
	'/fr/film/alucarda': 'V2',
	'/fr/film/annie-1999': 'V3',
	'/fr/film/alison-2016': 'V1',
	'/fr/film/33-photos-from-the-ghetto': 'V2',
	'/fr/film/black-box-diaries': 'V3',
	'/fr/film/asterix-le-gaulois': 'V1',
	'/fr/film/animal-lanimal': 'V2',
	'/fr/film/about-last-night-1986': 'V3',
	'/fr/film/baramulla': 'V1',
	'/fr/film/alvin-et-les-chipmunks-a-fond-la-caisse': 'V2',
	'/fr/film/96': 'V3',
	'/fr/film/alice-1988': 'V1',
	'/fr/film/barbie-apprentie-princesse': 'V2',
	'/fr/film/big-fat-liar': 'V3',
	'/fr/film/barbie-in-the-nutcracker': 'V1',
	'/fr/film/aniki-mon-frere': 'V2',
	'/fr/film/20-year-old-virgins': 'V3',
	'/fr/film/and-then-we-danced': 'V1',
	'/fr/film/bad-grandpa': 'V2',
	'/fr/film/blank-check': 'V3',
	'/fr/film/action-jackson': 'V1',
	'/fr/film/a-hitman-in-london': 'V2',
	'/fr/film/be-cool': 'V3',
	'/fr/film/balloon': 'V1',
	'/fr/film/air-force-bat-21': 'V2',
	'/fr/film/beethovens-2nd': 'V3',
	'/fr/film/berlin-syndrome': 'V1',
	'/fr/film/above-suspicion-2019': 'V2',
	'/fr/film/balada-triste': 'V3',
	'/fr/film/after-the-dark': 'V1',
	'/fr/film/45-ans': 'V2',
	'/fr/film/adieu-je-reste': 'V3',
	'/fr/film/bardo-false-chronicle-of-a-handful-of-truths': 'V1',
	'/fr/film/albert-nobbs': 'V2',
	'/fr/film/all-the-pretty-horses': 'V3',
	'/fr/film/30-jours-de-nuit-jours-sombres': 'V1',
	'/fr/film/berlinguer-la-grande-ambizione-2024': 'V2',
	'/fr/film/13-tzameti': 'V3',
	'/fr/film/black-cat-white-cat': 'V1',
	'/fr/film/after-the-wedding': 'V2',
	'/fr/film/bleu-denfer-2': 'V3',
	'/fr/film/a-notre-beau-metier': 'V1',
	'/fr/film/angel-a': 'V2',
	'/fr/film/atlantic-city': 'V3',
	'/fr/film/all-the-old-knives': 'V1',
	'/fr/film/anything-else-la-vie-et-tout-le-reste': 'V2',
	'/fr/film/barbershop': 'V3',
	'/fr/film/anchor': 'V1',
	'/fr/film/beautiful-thing': 'V2',
	'/fr/film/bliss-2019': 'V3',
	'/fr/film/all-about-steve': 'V1',
	'/fr/film/band-aid': 'V2',
	'/fr/film/above-the-law': 'V3',
	'/fr/film/attention-on-va-sfacher': 'V1',
	'/fr/film/a-plein-temps': 'V2',
	'/fr/film/anne-des-mille-jours': 'V3',
	'/fr/film/au-dessus-des-lois': 'V1',
	'/fr/film/aadujeevitham': 'V2',
	'/fr/film/alfie-1966': 'V3',
	'/fr/film/beach-rats': 'V1',
	'/fr/film/bad-boys-1983': 'V2',
	'/fr/film/assassination-games': 'V3',
	'/fr/film/alligator': 'V1',
	'/fr/film/american-ninja-3-la-chasse-sanglante': 'V2',
	'/fr/film/bad-cat': 'V3',
	'/fr/film/benediction': 'V1',
	'/fr/film/bleach': 'V2',
	'/fr/film/a-double-tranchant': 'V3',
	'/fr/film/batman-ninja': 'V1',
	'/fr/film/beavis-and-butt-head-do-america': 'V2',
	'/fr/film/anacoreta': 'V3',
	'/fr/film/anselm': 'V1',
	'/fr/film/batman-les-origines': 'V2',
	'/fr/film/bad-guy': 'V3',
	'/fr/film/american-yakuza': 'V1',
	'/fr/film/27-nights': 'V2',
	'/fr/film/arctic-void': 'V3',
	'/fr/film/antwone-fisher': 'V1',
	'/fr/film/be-my-teacher': 'V2',
	'/fr/film/banlieue-13-ultimatum': 'V3',
	'/fr/film/be-my-cat-a-film-for-anne': 'V1',
	'/fr/film/bernard-et-bianca-au-pays-des-kangourous': 'V2',
	'/fr/film/bandidas': 'V3',
	'/fr/film/barbie-of-swan-lake': 'V1',
	'/fr/film/a-private-war': 'V2',
	'/fr/film/arizona-dream': 'V3',
	'/fr/film/18-cadeaux': 'V1',
	'/fr/film/beauty-shop': 'V2',
	'/fr/film/batman-the-long-halloween-part-one': 'V3',
	'/fr/film/black-beauty-1994': 'V1',
	'/fr/film/a-christmas-carol': 'V2',
	'/fr/film/a-la-recherche-de-vivian-maier': 'V3',
	'/fr/film/37-seconds': 'V1',
	'/fr/film/beaucoup-de-bruit-pour-rien': 'V2',
	'/fr/film/ambush': 'V3',
	'/fr/film/agent-secret': 'V1',
	'/fr/film/bienvenue-a-cedar-rapids': 'V2',
	'/fr/film/angel-1984': 'V3',
	'/fr/film/10-years': 'V1',
	'/fr/film/a-deadly-american-marriage': 'V2',
	'/fr/film/abattoir-5': 'V3',
	'/fr/film/banlieusards-2': 'V1',
	'/fr/film/april-2026': 'V2',
	'/fr/film/abruptio': 'V3',
	'/fr/film/becket': 'V1',
	'/fr/film/american-psycho-2-all-american-girl': 'V2',
	'/fr/film/being-the-ricardos': 'V3',
	'/fr/film/antiporno': 'V1',
	'/fr/film/archipelago-2011': 'V2',
	'/fr/film/anatomy-of-hell': 'V3',
	'/fr/film/allan-quatermain-et-les-mines-du-roi-salomon': 'V1',
	'/fr/film/behind-the-curve': 'V2',
	'/fr/film/beatles-64': 'V3',
	'/fr/film/a-tous-les-garcons-p-s-je-taime-toujours': 'V1',
	'/fr/film/birdy': 'V2',
	'/fr/film/blood-father': 'V3',
	'/fr/film/big-jake': 'V1',
	'/fr/film/a-cursed-man': 'V2',
	'/fr/film/batman-la-releve-le-retour-du-joker': 'V3',
	'/fr/film/being-eddie': 'V1',
	'/fr/film/american-woman': 'V2',
	'/fr/film/azur-et-asmar': 'V3',
	'/fr/film/aka': 'V1',
	'/fr/film/berserk-lage-dor-partie-1-loeuf-du-roi-conquerant': 'V2',
	'/fr/film/asterix-le-domaine-des-dieux': 'V3',
	'/fr/film/bait-2012': 'V1',
	'/fr/film/amer': 'V2',
	'/fr/film/8-vasantalu': 'V3',
	'/fr/film/age-of-consent-1969': 'V1',
	'/fr/film/a-war-story-2019': 'V2',
	'/fr/film/a-journal-for-jordan': 'V3',
	'/fr/film/3-from-hell': 'V1',
	'/fr/film/american-haunting': 'V2',
	'/fr/film/aftermath-2024': 'V3',
	'/fr/film/bad-ass': 'V1',
	'/fr/film/arrete-avec-tes-mensonges': 'V2',
	'/fr/film/appropriate-behavior': 'V3',
	'/fr/film/bent': 'V1',
	'/fr/film/16-voeux': 'V2',
	'/fr/film/akelarre': 'V3',
	'/fr/film/7-risque-and-erotic-tales': 'V1',
	'/fr/film/amanda': 'V2',
	'/fr/film/a-chacun-sa-guerre': 'V3',
	'/fr/film/asterix-and-the-vikings': 'V1',
	'/fr/film/avant-le-deluge': 'V2',
	'/fr/film/batman-the-dark-knight-returns-part-2': 'V3',
	'/fr/film/american-pastoral': 'V1',
	'/fr/film/beau-pere': 'V2',
	'/fr/film/36th-precinct': 'V3',
	'/fr/film/bad-milo': 'V1',
	'/fr/film/above-the-shadows': 'V2',
	'/fr/film/bac-nord': 'V3',
	'/fr/film/apres-la-tempete': 'V1',
	'/fr/film/a-bout-de-souffle-made-in-usa': 'V2',
	'/fr/film/atomic-college': 'V3',
	'/fr/film/a-soldiers-story-1984': 'V1',
	'/fr/film/beyond-skyline': 'V2',
	'/fr/film/anima-2019': 'V3',
	'/fr/film/another-body': 'V1',
	'/fr/film/alias-jesse-james': 'V2',
	'/fr/film/banana-joe': 'V3',
	'/fr/film/bad-trip-2020': 'V1',
	'/fr/film/14-peaks-nothing-is-impossible': 'V2',
	'/fr/film/blood-2022-0': 'V3',
	'/fr/film/black-flies': 'V1',
	'/fr/film/bigfoot-junior': 'V2',
	'/fr/film/12-heures': 'V3',
	'/fr/film/assassin-2024': 'V1',
	'/fr/film/badland-hunters': 'V2',
	'/fr/film/batman-vs-robin': 'V3',
	'/fr/film/alex-rider-stormbreaker': 'V1',
	'/fr/film/amazing-grace': 'V2',
	'/fr/film/between-the-temples': 'V3',
	'/fr/film/au-risque-de-se-perdre': 'V1',
	'/fr/film/42eme-rue': 'V2',
	'/fr/film/au-coeur-de-la-tempete-2010': 'V3',
	'/fr/film/black-mountain-side': 'V1',
	'/fr/film/big-mamma-2': 'V2',
	'/fr/film/always-at-the-carlyle': 'V3',
	'/fr/film/black-2005': 'V1',
	'/fr/film/blancanieves': 'V2',
	'/fr/film/bananas': 'V3',
	'/fr/film/after-the-wedding-2019': 'V1',
	'/fr/film/bad-company-1972': 'V2',
	'/fr/film/a-travers-le-miroir': 'V3',
	'/fr/film/an-american-werewolf-in-paris': 'V1',
	'/fr/film/an-angel-at-my-table': 'V2',
	'/fr/film/awake-2021': 'V3',
	'/fr/film/bad-yankee': 'V1',
	'/fr/film/all-the-way': 'V2',
	'/fr/film/a-good-old-fashioned-orgy': 'V3',
	'/fr/film/blind-fury': 'V1',
	'/fr/film/a-la-conquete-dun-coeur': 'V2',
	'/fr/film/a-mistake': 'V3',
	'/fr/film/ala-vaikunthapurramuloo': 'V1',
	'/fr/film/blood-money-2017': 'V2',
	'/fr/film/angels-of-revolution': 'V3',
	'/fr/film/a-lheure-des-souvenirs': 'V1',
	'/fr/film/acide-2023': 'V2',
	'/fr/film/big-business': 'V3',
	'/fr/film/anvil': 'V1',
	'/fr/film/13': 'V2',
	'/fr/film/barbie-et-le-secret-des-sirenes': 'V3',
	'/fr/film/2eme-sous-sol': 'V1',
	'/fr/film/atl': 'V2',
	'/fr/film/aladdin-et-le-roi-des-voleurs': 'V3',
	'/fr/film/beloved': 'V1',
	'/fr/film/blazing-magnum': 'V2',
	'/fr/film/a-dirty-shame': 'V3',
	'/fr/film/all-my-life-2020': 'V1',
	'/fr/film/absolute-beginners': 'V2',
	'/fr/film/alphago': 'V3',
	'/fr/film/another-end': 'V1',
	'/fr/film/bajrangi-bhaijaan': 'V2',
	'/fr/film/agnes-of-god': 'V3',
	'/fr/film/bagarres-au-king-creole': 'V1',
	'/fr/film/animal-factory-2000': 'V2',
	'/fr/film/1776': 'V3',
	'/fr/film/a-merry-little-ex-mas': 'V1',
	'/fr/film/avril-enchante': 'V2',
	'/fr/film/a-woman-is-a-woman': 'V3',
	'/fr/film/blackbird-2019': 'V1',
	'/fr/film/article-370': 'V2',
	'/fr/film/before-and-after': 'V3',
	'/fr/film/altman': 'V1',
	'/fr/film/berberian-sound-studio': 'V2',
	'/fr/film/apollo-101-2-a-space-age-childhood': 'V3',
	'/fr/film/360': 'V1',
	'/fr/film/black-island': 'V2',
	'/fr/film/bao': 'V3',
	'/fr/film/batman-mauvais-sang': 'V1',
	'/fr/film/biker-boyz': 'V2',
	'/fr/film/all-fun-and-games': 'V3',
	'/fr/film/birds-of-passage': 'V1',
	'/fr/film/au-coeur-des-volcans-requiem-pour-katia-et-maurice-krafft': 'V2',
	'/fr/film/bleu-nuit': 'V3',
	'/fr/film/big-boys': 'V1',
	'/fr/film/a-very-jonas-christmas-movie': 'V2',
	'/fr/film/ainsi-va-la-vie': 'V3',
	'/fr/film/bartok-le-magnifique': 'V1',
	'/fr/film/adieu-monsieur-haffmann': 'V2',
	'/fr/film/albator-corsaire-de-lespace': 'V3',
	'/fr/film/blood-et-gold': 'V1',
	'/fr/film/army-of-one-2020': 'V2',
	'/fr/film/about-last-night': 'V3',
	'/fr/film/black-dog': 'V1',
	'/fr/film/a-sa-place': 'V2',
	'/fr/film/100-metros': 'V3',
	'/fr/film/anacondas-4-la-piste-du-sang': 'V1',
	'/fr/film/adieu-les-cons': 'V2',
	'/fr/film/a-house-on-the-bayou': 'V3',
	'/fr/film/blood-creek': 'V1',
	'/fr/film/aporia-2023': 'V2',
	'/fr/film/15-minutes': 'V3',
	'/fr/film/black-box': 'V1',
	'/fr/film/any-which-way-you-can': 'V2',
	'/fr/film/avril-et-le-monde-truque': 'V3',
	'/fr/film/13-fantomes': 'V1',
	'/fr/film/bataille-pour-haditha': 'V2',
	'/fr/film/batman-gotham-by-gaslight': 'V3',
	'/fr/film/battlestar-galactica-blood-and-chrome': 'V1',
	'/fr/film/battle-beyond-mars': 'V2',
	'/fr/film/balkan-line': 'V3',
	'/fr/film/ames-en-stock': 'V1',
	'/fr/film/an-affair-to-die-for': 'V2',
	'/fr/film/187-code-meurtre': 'V3',
	'/fr/film/15-cameras': 'V1',
	'/fr/film/bad-santa-2': 'V2',
	'/fr/film/amityville-the-awakening': 'V3',
	'/fr/film/bang-gang-une-histoire-damour-moderne': 'V1',
	'/fr/film/atlantis-milos-return': 'V2',
	'/fr/film/102-dalmatians': 'V3',
	'/fr/film/becoming-2020': 'V1',
	'/fr/film/99-francs': 'V2',
	'/fr/film/anatomy': 'V3',
	'/fr/film/a-love-song-for-bobby-long': 'V1',
	'/fr/film/antonias-line': 'V2',
	'/fr/film/alexandre-et-sa-journee-epouvantablement-terrible-horrible-et-affreuse': 'V3',
	'/fr/film/a-touch-of-sin': 'V1',
	'/fr/film/31': 'V2',
	'/fr/film/24-heures-chrono-redemption': 'V3',
	'/fr/film/barfi': 'V1',
	'/fr/film/alice-to-therese-no-maboroshi-kojo': 'V2',
	'/fr/film/apache': 'V3',
	'/fr/film/alec-baldwin-shock-et-sadness': 'V1',
	'/fr/film/12-hour-shift': 'V2',
	'/fr/film/affinity': 'V3',
	'/fr/film/bhouri': 'V1',
	'/fr/film/2050': 'V2',
	'/fr/film/batman-the-dark-knight-returns': 'V3',
	'/fr/film/blood-2012': 'V1',
	'/fr/film/bakas-identity': 'V2',
	'/fr/film/augusta-gone': 'V3',
	'/fr/film/beat-street': 'V1',
	'/fr/film/babo-die-haftbefehl-story': 'V2',
	'/fr/film/blacula-le-vampire-noir': 'V3',
	'/fr/film/bienvenue-monsieur-marshall': 'V1',
	'/fr/film/a-little-romance': 'V2',
	'/fr/film/another-gay-movie': 'V3',
	'/fr/film/a-war': 'V1',
	'/fr/film/among-wolves': 'V2',
	'/fr/film/american-outlaws': 'V3',
	'/fr/film/a-taste-of-hunger-2021': 'V1',
	'/fr/film/ahlat-agaci': 'V2',
	'/fr/film/baba-yaga': 'V3',
	'/fr/film/audrey-rose': 'V1',
	'/fr/film/alexandre-le-grand': 'V2',
	'/fr/film/aileen-queen-of-the-serial-killers': 'V3',
	'/fr/film/amityville-ii-the-possession': 'V1',
	'/fr/film/batman-death-in-the-family': 'V2',
	'/fr/film/bliss-2021': 'V3',
	'/fr/film/babysitting-2': 'V1',
	'/fr/film/batman-contre-dracula': 'V2',
	'/fr/film/bigbug': 'V3',
	'/fr/film/amanda-knox': 'V1',
	'/fr/film/arlen-faber': 'V2',
	'/fr/film/a-walk-on-the-moon': 'V3',
	'/fr/film/batman-la-malediction-qui-sabattit-sur-gotham': 'V1',
	'/fr/film/american-dreamer-2024': 'V2',
	'/fr/film/avicii-im-tim': 'V3',
	'/fr/film/at-first-sight': 'V1',
	'/fr/film/bleeding-steel': 'V2',
	'/fr/film/a-true-gentleman': 'V3',
	'/fr/film/ariane': 'V1',
	'/fr/film/apex': 'V2',
	'/fr/film/allons-donc-papa': 'V3',
	'/fr/film/2001-maniacs-field-of-screams': 'V1',
	'/fr/film/1883-the-road-west': 'V2',
	'/fr/film/adam-and-paul': 'V3',
	'/fr/film/asterix-et-la-surprise-de-cesar': 'V1',
	'/fr/film/49e-parallele': 'V2',
	'/fr/film/adieu-ma-belle': 'V3',
	'/fr/film/appelez-moi-dj-rebel': 'V1',
	'/fr/film/2-ou-3-choses-que-je-sais-delle': 'V2',
	'/fr/film/bereavement': 'V3',
	'/fr/film/a-beautiful-life-2023': 'V1',
	'/fr/film/12-rounds': 'V2',
	'/fr/film/american-girls-4': 'V3',
	'/fr/film/amelia': 'V1',
	'/fr/film/assassins-2021': 'V2',
	'/fr/film/abigail-le-pouvoir-de-lelue': 'V3',
	'/fr/film/at-berkeley': 'V1',
	'/fr/film/amazing-grace-2015': 'V2',
	'/fr/film/being-maria': 'V3',
	'/fr/film/association-criminelle': 'V1',
	'/fr/film/2-0': 'V2',
	'/fr/film/barbie-et-le-palais-de-diamant': 'V3',
	'/fr/film/andy-irons-kissed-by-god': 'V1',
	'/fr/film/arthur-3-la-guerre-des-deux-mondes': 'V2',
	'/fr/film/batman-the-long-halloween-2eme-partie': 'V3',
	'/fr/film/best-of-enemies': 'V1',
	'/fr/film/batman-and-mr-freeze-subzero': 'V2',
	'/fr/film/batman-gotham-knight': 'V3',
	'/fr/film/always-2011': 'V1',
	'/fr/film/alleluia': 'V2',
	'/fr/film/9-11': 'V3',
	'/fr/film/all-that-breathes': 'V1',
	'/fr/film/armed-and-dangerous': 'V2',
	'/fr/film/au-revoir-mr-chips': 'V3',
	'/fr/film/blade-runner-black-out-2022': 'V1',
	'/fr/film/avec-amour-et-acharnement': 'V2',
	'/fr/film/armageddon-code': 'V3',
	'/fr/film/baby-assassins-2': 'V1',
	'/fr/film/bad-faith-christian-nationalisms-unholy-war-on-democracy': 'V2',
	'/fr/film/amos-and-andrew': 'V3',
	'/fr/film/avgrunden': 'V1',
	'/fr/film/a-bicyclette': 'V2',
	'/fr/film/3some': 'V3',
	'/fr/film/amerikatsi': 'V1',
	'/fr/film/blankman': 'V2',
	'/fr/film/7-prisioneiros': 'V3',
	'/fr/film/an-evening-with-beverly-luff-linn': 'V1',
	'/fr/film/bebes-kids': 'V2',
	'/fr/film/a-sun': 'V3',
	'/fr/film/billy-et-molly-un-amour-de-loutre': 'V1',
	'/fr/film/au-fil-du-temps': 'V2',
	'/fr/film/ali-and-ava': 'V3',
	'/fr/film/baki-hanma-vs-kengan-ashura': 'V1',
	'/fr/film/bianco-rosso-e-verdone': 'V2',
	'/fr/film/bed-and-board': 'V3',
	'/fr/film/bang-bang-2014': 'V1',
	'/fr/film/band-baaja-baaraat': 'V2',
	'/fr/film/a-mouthful-of-air': 'V3',
	'/fr/film/35-rhums': 'V1',
	'/fr/film/a-rough-draft': 'V2',
	'/fr/film/bachna-ae-haseeno': 'V3',
	'/fr/film/bilitis': 'V1',
	'/fr/film/2069-a-sex-odyssey': 'V2',
	'/fr/film/a-perfect-pairing': 'V3',
	'/fr/film/a-coeur-vaillant-rien-dimpossible': 'V1',
	'/fr/film/80-for-brady': 'V2',
	'/fr/film/a-bout-portant': 'V3',
	'/fr/film/almost-christmas': 'V1',
	'/fr/film/101-dalmatians-ii-patchs-london-adventure': 'V2',
	'/fr/film/annee-bissextile': 'V3',
	'/fr/film/admiral': 'V1',
	'/fr/film/aliens-special-edition-1986': 'V2',
	'/fr/film/25-litre': 'V3',
	'/fr/film/abyzou': 'V1',
	'/fr/film/antonia-la-chef-dorchestre': 'V2',
	'/fr/film/big-top-pee-wee': 'V3',
	'/fr/film/ariel': 'V1',
	'/fr/film/asylum-2005': 'V2',
	'/fr/film/all-summers-end': 'V3',
	'/fr/film/au-bord-du-gouffre': 'V1',
	'/fr/film/a-single-shot': 'V2',
	'/fr/film/2012-zombie-apocalypse': 'V3',
	'/fr/film/art-school-confidential': 'V1',
	'/fr/film/agent-cody-banks-2-destination-london': 'V2',
	'/fr/film/arion': 'V3',
	'/fr/film/avril-brise': 'V1',
	'/fr/film/beowulf': 'V2',
	'/fr/film/baisers-caches': 'V3',
	'/fr/film/bad-girls': 'V1',
	'/fr/film/anniyan': 'V2',
	'/fr/film/allan-quatermain-and-the-lost-city-of-gold': 'V3',
	'/fr/film/15-ans-decart': 'V1',
	'/fr/film/bastion-36': 'V2',
	'/fr/film/asterix-et-le-coup-du-menhir': 'V3',
	'/fr/film/baiser-macabre': 'V1',
	'/fr/film/13-morts-et-demi': 'V2',
	'/fr/film/and-soon-the-darkness': 'V3',
	'/fr/film/5-to-7': 'V1',
	'/fr/film/24': 'V2',
	'/fr/film/3-ninjas-knuckle-up': 'V3',
	'/fr/film/afternoon-delight': 'V1',
	'/fr/film/a-travelers-needs': 'V2',
	'/fr/film/ahora-o-nunca': 'V3',
	'/fr/film/1st-strike': 'V1',
	'/fr/film/amours-salees-et-plaisirs-sucres': 'V2',
	'/fr/film/barbie-mariposa-et-ses-amies-les-fees-papillons': 'V3',
	'/fr/film/black-and-white': 'V1',
	'/fr/film/barbershop-the-next-cut': 'V2',
	'/fr/film/ben-10-versus-the-universe-the-movie': 'V3',
	'/fr/film/aigle-de-fer-2': 'V1',
	'/fr/film/america-america': 'V2',
	'/fr/film/alice-au-pays-des-merveilles-1972': 'V3',
	'/fr/film/anna-karenine-1948': 'V1',
	'/fr/film/a-dix-sept-ans': 'V2',
	'/fr/film/anna-karenine-1997': 'V3',
	'/fr/film/bed-rest': 'V1',
	'/fr/film/absolutely-fabulous-the-movie': 'V2',
	'/fr/film/baltimore-2024': 'V3',
	'/fr/film/bad-day': 'V1',
	'/fr/film/autumn-tale': 'V2',
	'/fr/film/all-russians-love-birch-trees': 'V3',
	'/fr/film/agneepath-1990': 'V1',
	'/fr/film/bill-burr-drop-dead-years': 'V2',
	'/fr/film/be-with-yo': 'V3',
	'/fr/film/beneath-2007': 'V1',
	'/fr/film/battle-drone': 'V2',
	'/fr/film/amaran': 'V3',
	'/fr/film/ainbo-princesse-damazonie': 'V1',
	'/fr/film/bielorussie-presidente-malgre-elle': 'V2',
	'/fr/film/bill-nye-science-guy': 'V3',
	'/fr/film/batman-assaut-sur-arkham': 'V1',
	'/fr/film/bananas-2009': 'V2',
	'/fr/film/after-2012': 'V3',
	'/fr/film/bethlehem': 'V1',
	'/fr/film/a-charlie-brown-thanksgiving': 'V2',
	'/fr/film/across-the-river-2013': 'V3',
	'/fr/film/blood-and-wine': 'V1',
	'/fr/film/audrey-hepburn-douleur-et-gloire': 'V2',
	'/fr/film/agents-secrets': 'V3',
	'/fr/film/azul': 'V1',
	'/fr/film/a-closed-book': 'V2',
	'/fr/film/back-in-time': 'V3',
	'/fr/film/audrie-and-daisy': 'V1',
	'/fr/film/all-star-superman': 'V2',
	'/fr/film/barbie-princesse-de-lile-merveilleuse': 'V3',
	'/fr/film/amelias-children': 'V1',
	'/fr/film/83': 'V2',
	'/fr/film/american-dharma': 'V3',
	'/fr/film/a-snake-of-june': 'V1',
	'/fr/film/anatar': 'V2',
	'/fr/film/battleship-island': 'V3',
	'/fr/film/american-satan': 'V1',
	'/fr/film/100-awit-para-kay-stella': 'V2',
	'/fr/film/beast-2022-0': 'V3',
	'/fr/film/all-we-had': 'V1',
	'/fr/film/affair-of-honor': 'V2',
	'/fr/film/a-normal-woman': 'V3',
	'/fr/film/a-la-limite-du-cauchemar': 'V1',
	'/fr/film/bay-of-angels': 'V2',
	'/fr/film/beyond-the-mask': 'V3',
	'/fr/film/beat-girl': 'V1',
	'/fr/film/black-coal': 'V2',
	'/fr/film/ailleurs-lherbe-est-plus-verte': 'V3',
	'/fr/film/a-pain-in-the-ass': 'V1',
	'/fr/film/alpha-2015': 'V2',
	'/fr/film/atanarjuat': 'V3',
	'/fr/film/a-c-a-b-all-cops-are-bastards': 'V1',
	'/fr/film/2036-origin-unknown': 'V2',
	'/fr/film/billy-budd': 'V3',
	'/fr/film/bessie': 'V1',
	'/fr/film/a-pornographic-affair': 'V2',
	'/fr/film/atsuko-okatsuka-father': 'V3',
	'/fr/film/a-fond': 'V1',
	'/fr/film/autopsy': 'V2',
	'/fr/film/arjun-reddy': 'V3',
	'/fr/film/adios': 'V1',
	'/fr/film/a-good-man': 'V2',
	'/fr/film/antares': 'V3',
	'/fr/film/a-futile-and-stupid-gesture': 'V1',
	'/fr/film/blackthorn-la-derniere-chevauchee-de-butch-cassidy': 'V2',
	'/fr/film/alien-hunter': 'V3',
	'/fr/film/azor': 'V1',
	'/fr/film/between-a-frock-and-a-hard-place': 'V2',
	'/fr/film/ben-1972': 'V3',
	'/fr/film/a-heist-with-markiplier': 'V1',
	'/fr/film/2-days-in-paris': 'V2',
	'/fr/film/3-jours-max': 'V3',
	'/fr/film/bigamie': 'V1',
	'/fr/film/a-second-chance': 'V2',
	'/fr/film/anastasia-1956': 'V3',
	'/fr/film/black-easter': 'V1',
	'/fr/film/barbershop-2-back-in-business': 'V2',
	'/fr/film/blazing-samurai': 'V3',
	'/fr/film/alvin-and-the-chipmunks-meet-the-wolfman': 'V1',
	'/fr/film/becoming-madonna': 'V2',
	'/fr/film/amal-2023': 'V3',
	'/fr/film/andhra-king-taluka': 'V1',
	'/fr/film/a-girl-at-my-door': 'V2',
	'/fr/film/avalon': 'V3',
	'/fr/film/alpha-et-omega': 'V1',
	'/fr/film/black-christmas-2019': 'V2',
	'/fr/film/aya-et-la-sorciere': 'V3',
	'/fr/film/american-sexy-phone': 'V1',
	'/fr/film/assassin-club': 'V2',
	'/fr/film/at-any-price': 'V3',
	'/fr/film/aqua-teen-forever-plantasm': 'V1',
	'/fr/film/blood-for-dust': 'V2',
	'/fr/film/baiser-mortel': 'V3',
	'/fr/film/bleu-saphir': 'V1',
	'/fr/film/4000-euros': 'V2',
	'/fr/film/admission': 'V3',
	'/fr/film/barbie-mariposa-et-le-royaume-des-fees': 'V1',
	'/fr/film/big-eden': 'V2',
	'/fr/film/after-porn-ends': 'V3',
	'/fr/film/amityvillenado': 'V1',
	'/fr/film/9-full-moons': 'V2',
	'/fr/film/beliers-2015': 'V3',
	'/fr/film/adam-2020': 'V1',
	'/fr/film/adrienne': 'V2',
	'/fr/film/au-poste': 'V3',
	'/fr/film/berlin-alexanderplatz': 'V1',
	'/fr/film/age-difficile-obscur': 'V2',
	'/fr/film/american-stories': 'V3',
	'/fr/film/amis-pour-la-vie': 'V1',
	'/fr/film/babysitting-night': 'V2',
	'/fr/film/alice-2022': 'V3',
	'/fr/film/bite-the-bullet': 'V1',
	'/fr/film/au-service-de-sara': 'V2',
	'/fr/film/a-travers-lorage': 'V3',
	'/fr/film/action-point': 'V1',
	'/fr/film/best-worst-thing-that-ever-could-have-happened': 'V2',
	'/fr/film/animaux-and-cie': 'V3',
	'/fr/film/alvin-and-the-chipmunks-meet-frankenstein': 'V1',
	'/fr/film/747-en-peril': 'V2',
	'/fr/film/28-hommes-de-panfilov': 'V3',
	'/fr/film/78-52': 'V1',
	'/fr/film/2-0-lucy': 'V2',
	'/fr/film/appel-inconnu': 'V3',
	'/fr/film/ariaferma': 'V1',
	'/fr/film/artistes-et-modeles': 'V2',
	'/fr/film/and-soon-the-darkness-1970': 'V3',
	'/fr/film/a-linterieur-daisy-clover': 'V1',
	'/fr/film/bad-ass-2': 'V2',
	'/fr/film/bianca': 'V3',
	'/fr/film/bernie': 'V1',
	'/fr/film/bataille-dans-le-ciel': 'V2',
	'/fr/film/a-simple-wish': 'V3',
	'/fr/film/atrocious': 'V1',
	'/fr/film/ashanti': 'V2',
	'/fr/film/au-dela-des-nuages': 'V3',
	'/fr/film/agneepath': 'V1',
	'/fr/film/anguish': 'V2',
	'/fr/film/bait': 'V3',
	'/fr/film/abrakadabra': 'V1',
	'/fr/film/a-handful-of-dust': 'V2',
	'/fr/film/badhaai-do': 'V3',
	'/fr/film/billy-liar': 'V1',
	'/fr/film/a-tale-of-springtime': 'V2',
	'/fr/film/as-i-was-moving-ahead-occasionally-i-saw-brief-glimpses-of-beauty': 'V3',
	'/fr/film/batman-soul-of-the-dragon': 'V1',
	'/fr/film/bienvenue-a-collinwood': 'V2',
	'/fr/film/9-april': 'V3',
	'/fr/film/a-des-millions-de-kilometres-de-la-terre': 'V1',
	'/fr/film/bel-ami': 'V2',
	'/fr/film/banco': 'V3',
	'/fr/film/athlete-a': 'V1',
	'/fr/film/barbie-reve-de-danseuse-etoile': 'V2',
	'/fr/film/battle-of-the-year': 'V3',
	'/fr/film/1945': 'V1',
	'/fr/film/anatomy-of-a-love-seen': 'V2',
	'/fr/film/200-000-dollars-en-cavale': 'V3',
	'/fr/film/baron-rouge': 'V1',
	'/fr/film/batman-and-superman-battle-of-the-super-sons': 'V2',
	'/fr/film/alive-and-kicking': 'V3',
	'/fr/film/angel-eyes': 'V1',
	'/fr/film/birds-of-paradise': 'V2',
	'/fr/film/7th-floor': 'V3',
	'/fr/film/7-guardians-of-the-tomb': 'V1',
	'/fr/film/backpackers': 'V2',
	'/fr/film/bi-nu': 'V3',
	'/fr/film/bacchanales-erotiques': 'V1',
	'/fr/film/anthony-jeselnik-bones-and-all': 'V2',
	'/fr/film/as-you-like-it': 'V3',
	'/fr/film/alex-strangelove': 'V1',
	'/fr/film/a-nous-la-liberte': 'V2',
	'/fr/film/allo-brigade-speciale': 'V3',
	'/fr/film/berceuse-mortelle': 'V1',
	'/fr/film/anacleto-agente-secreto': 'V2',
	'/fr/film/aenigma': 'V3',
	'/fr/film/after-porn-ends-2': 'V1',
	'/fr/film/another-day-in-paradise': 'V2',
	'/fr/film/009-1-the-end-of-the-beginning': 'V3',
	'/fr/film/4th-man-out': 'V1',
	'/fr/film/after-porn-ends-3': 'V2',
	'/fr/film/as-i-lay-dying': 'V3',
	'/fr/film/bibi-blocksberg-et-le-secret-des-chouettes-bleues': 'V1',
	'/fr/film/4-little-girls': 'V2',
	'/fr/film/adults-in-the-room': 'V3',
	'/fr/film/4-20-massacre': 'V1',
	'/fr/film/and-while-we-were-here': 'V2',
	'/fr/film/a-private-function': 'V3',
	'/fr/film/blame-the-game': 'V1',
	'/fr/film/america-le-film': 'V2',
	'/fr/film/abandoned': 'V3',
	'/fr/film/all-saints': 'V1',
	'/fr/film/arret-dautobus': 'V2',
	'/fr/film/baby-geniuses': 'V3',
	'/fr/film/between-worlds': 'V1',
	'/fr/film/active-measures': 'V2',
	'/fr/film/abominable-2006': 'V3',
	'/fr/film/batman-return-of-the-caped-crusaders': 'V1',
	'/fr/film/amants-1991': 'V2',
	'/fr/film/a-nice-quiet-life': 'V3',
	'/fr/film/bis-zum-ellenbogen': 'V1',
	'/fr/film/12-h-08-a-lest-de-bucarest': 'V2',
	'/fr/film/atomic-cafe': 'V3',
	'/fr/film/annie-la-reine-du-cirque': 'V1',
	'/fr/film/animal-2014': 'V2',
	'/fr/film/aftermath-2021': 'V3',
	'/fr/film/a-armes-egales': 'V1',
	'/fr/film/anjaam': 'V2',
	'/fr/film/aux-postes-de-combat': 'V3',
	'/fr/film/blaze-2024': 'V1',
	'/fr/film/a-night-of-knowing-nothing': 'V2',
	'/fr/film/all-dogs-go-to-heaven-2': 'V3',
	'/fr/film/a-lecoute-du-ventre-les-secrets-de-votre-sante': 'V1',
	'/fr/film/berserk-lage-dor-partie-3-la-descente-aux-enfers': 'V2',
	'/fr/film/a-k': 'V3',
	'/fr/film/berlin-i-love-you': 'V1',
	'/fr/film/and-god-created-woman': 'V2',
	'/fr/film/1': 'V3',
	'/fr/film/12-rounds-3-lockdown': 'V1',
	'/fr/film/anything-goes': 'V2',
	'/fr/film/altered-carbon-resleeved': 'V3',
	'/fr/film/anuja': 'V1',
	'/fr/film/barry': 'V2',
	'/fr/film/belly-of-the-beast': 'V3',
	'/fr/film/bigfoot': 'V1',
	'/fr/film/au-dela-du-desir': 'V2',
	'/fr/film/aftersun-2006': 'V3',
	'/fr/film/best-of-the-best-3-no-turning-back': 'V1',
	'/fr/film/a-very-englishman': 'V2',
	'/fr/film/aimee-and-jaguar': 'V3',
	'/fr/film/a-white-white-day': 'V1',
	'/fr/film/11m-terror-in-madrid': 'V2',
	'/fr/film/avicii-true-stories': 'V3',
	'/fr/film/a-secret-love': 'V1',
	'/fr/film/air-force-elite-thunderbirds': 'V2',
	'/fr/film/archenemy': 'V3',
	'/fr/film/basket-academy': 'V1',
	'/fr/film/ascension-2021': 'V2',
	'/fr/film/400-days': 'V3',
	'/fr/film/approaching-the-unknown': 'V1',
	'/fr/film/a-chiara': 'V2',
	'/fr/film/au-bain-des-dames': 'V3',
	'/fr/film/an-innocent-man': 'V1',
	'/fr/film/arthur-and-merlin-knights-of-camelot': 'V2',
	'/fr/film/bibi-blocksberg-lapprentie-sorciere': 'V3',
	'/fr/film/between-your-legs': 'V1',
	'/fr/film/all-this-and-heaven-too': 'V2',
	'/fr/film/angelique-marquise-des-anges': 'V3',
	'/fr/film/aime-et-fais-ce-que-tu-veux': 'V1',
	'/fr/film/bare-hands': 'V2',
	'/fr/film/bill-evans-time-remembered': 'V3',
	'/fr/film/baby-needs-a-new-pair-of-shoes': 'V1',
	'/fr/film/baby-secret-of-the-lost-legend': 'V2',
	'/fr/film/allure-2018': 'V3',
	'/fr/film/alaska': 'V1',
	'/fr/film/american-dreamz': 'V2',
	'/fr/film/american-beach-house': 'V3',
	'/fr/film/batman-vs-two-face': 'V1',
	'/fr/film/avant-que-nous-disparaissions': 'V2',
	'/fr/film/afterschool': 'V3',
	'/fr/film/banger-2025': 'V1',
	'/fr/film/13-exorcismos': 'V2',
	'/fr/film/a-record-of-sweet-murder': 'V3',
	'/fr/film/above-suspicion': 'V1',
	'/fr/film/2072-les-mercenaires-du-futur': 'V2',
	'/fr/film/10-jours-sans-maman': 'V3',
	'/fr/film/altamira': 'V1',
	'/fr/film/a-merry-friggin-christmas': 'V2',
	'/fr/film/antboy': 'V3',
	'/fr/film/blackout-2022': 'V1',
	'/fr/film/belle-et-sebastien-3': 'V2',
	'/fr/film/adu': 'V3',
	'/fr/film/big-time-movie': 'V1',
	'/fr/film/aileen-life-and-death-of-a-serial-killer': 'V2',
	'/fr/film/alexander-revisited-the-final-cut': 'V3',
	'/fr/film/a-day-to-die': 'V1',
	'/fr/film/a-scene-at-the-sea': 'V2',
	'/fr/film/bad-hair': 'V3',
	'/fr/film/au-loin-sen-vont-les-nuages': 'V1',
	'/fr/film/bleu-profond': 'V2',
	'/fr/film/au-coeur-de-minuit': 'V3',
	'/fr/film/adventures-of-a-mathematician': 'V1',
	'/fr/film/big-boys-dont-cry': 'V2',
	'/fr/film/anti-life': 'V3',
	'/fr/film/bayonetta-bloody-fate': 'V1',
	'/fr/film/a-far-off-place': 'V2',
	'/fr/film/a-midsummer-nights-dream-2016': 'V3',
	'/fr/film/amour-defendu': 'V1',
	'/fr/film/a-farewell-to-ozark': 'V2',
	'/fr/film/amies-malgre-lui': 'V3',
	'/fr/film/303': 'V1',
	'/fr/film/at-the-devils-door': 'V2',
	'/fr/film/blackbird-blackbird-blackberry': 'V3',
	'/fr/film/bergman-a-year-in-life': 'V1',
	'/fr/film/an-action-hero': 'V2',
	'/fr/film/banana-split': 'V3',
	'/fr/film/azumi': 'V1',
	'/fr/film/a-song-of-the-girl': 'V2',
	'/fr/film/4-aventures-de-reinette-et-mirabelle': 'V3',
	'/fr/film/banksy-la-revolution-street-art': 'V1',
	'/fr/film/angelique': 'V2',
	'/fr/film/bit': 'V3',
	'/fr/film/abzurdah': 'V1',
	'/fr/film/accused': 'V2',
	'/fr/film/22-vs-earth': 'V3',
	'/fr/film/attraction-2008': 'V1',
	'/fr/film/aria': 'V2',
	'/fr/film/7-anos': 'V3',
	'/fr/film/antkaarm': 'V1',
	'/fr/film/aux-frontieres-des-indes': 'V2',
	'/fr/film/bachelor-mother': 'V3',
	'/fr/film/another-day-of-life': 'V1',
	'/fr/film/aileen-wuornos-american-boogeywoman': 'V2',
	'/fr/film/amour-and-turbulences': 'V3',
	'/fr/film/a-2nd-chance': 'V1',
	'/fr/film/7-jours-a-la-havane': 'V2',
	'/fr/film/alien-autopsy': 'V3',
	'/fr/film/a-ha-the-movie': 'V1',
	'/fr/film/barbie-laventure-de-princesse': 'V2',
	'/fr/film/4-de-lapocalypse': 'V3',
	'/fr/film/anna-karenine': 'V1',
	'/fr/film/anythings-possible': 'V2',
	'/fr/film/barbie-spy-squad': 'V3',
	'/fr/film/1985': 'V1',
	'/fr/film/backtrace': 'V2',
	'/fr/film/back-roads': 'V3',
	'/fr/film/adipurush': 'V1',
	'/fr/film/barbarians-2021': 'V2',
	'/fr/film/a-nonsense-christmas-with-sabrina-carpenter': 'V3',
	'/fr/film/backdraft-2': 'V1',
	'/fr/film/bawaal': 'V2',
	'/fr/film/ava': 'V3',
	'/fr/film/american-symphony': 'V1',
	'/fr/film/40-ans-toujours-dans-le-flow': 'V2',
	'/fr/film/blind-2017': 'V3',
	'/fr/film/barbie-et-la-magie-des-perles': 'V1',
	'/fr/film/american-cyborg-steel-warrior': 'V2',
	'/fr/film/avalanche-1978': 'V3',
	'/fr/film/beyond-the-deep': 'V1',
	'/fr/film/ana-and-bruno': 'V2',
	'/fr/film/barry-le-roi-du-disco': 'V3',
	'/fr/film/annibal': 'V1',
	'/fr/film/a-day-of-judgment': 'V2',
	'/fr/film/battle-for-honor-la-bataille-de-brest-litovsk': 'V3',
	'/fr/film/ali-wong-baby-cobra': 'V1',
	'/fr/film/ante-sundharaniki': 'V2',
	'/fr/film/au-nom-du-peuple-italien': 'V3',
	'/fr/film/a-little-white-lie': 'V1',
	'/fr/film/belle-et-sebastien-nouvelle-generation-2022': 'V2',
	'/fr/film/baccalaureat': 'V3',
	'/fr/film/13-factors-that-saved-apollo-13': 'V1',
	'/fr/film/alibi-2006': 'V2',
	'/fr/film/aleksandrs-price': 'V3',
	'/fr/film/anthropocene-lere-humaine': 'V1',
	'/fr/film/aftershock-lenfer-sur-terre': 'V2',
	'/fr/film/angie': 'V3',
	'/fr/film/blanche-comme-neige': 'V1',
	'/fr/film/and-they-lived-happily-ever-after': 'V2',
	'/fr/film/267': 'V3',
	'/fr/film/amateur-teens': 'V1',
	'/fr/film/4h44-dernier-jour-sur-terre': 'V2',
	'/fr/film/2-guns-zero-tolerance': 'V3',
	'/fr/film/36-hours': 'V1',
	'/fr/film/barbie-et-la-porte-secrete': 'V2',
	'/fr/film/belphegor-phantom-of-the-louvre': 'V3',
	'/fr/film/au-coeur-de-lapocalypse': 'V1',
	'/fr/film/australia-after-dark': 'V2',
	'/fr/film/agent-x27': 'V3',
	'/fr/film/anarchy': 'V1',
	'/fr/film/731-two-versions-of-hell': 'V2',
	'/fr/film/blood-money': 'V3',
	'/fr/film/alice-adams': 'V1',
	'/fr/film/baby-boss-le-bonus-de-noel': 'V2',
	'/fr/film/altitude': 'V3',
	'/fr/film/anweshippin-kandethum': 'V1',
	'/fr/film/black-emanuelle-en-amerique': 'V2',
	'/fr/film/a-wednesday': 'V3',
	'/fr/film/bataille-dans-lespace': 'V1',
	'/fr/film/battle-for-terra': 'V2',
	'/fr/film/barbe-bleue': 'V3',
	'/fr/film/au-dela-de-lillusion': 'V1',
	'/fr/film/amours-and-trahisons': 'V2',
	'/fr/film/ambrosia': 'V3',
	'/fr/film/bambi-lhistoire-dune-vie-dans-les-bois': 'V1',
	'/fr/film/betrayal': 'V2',
	'/fr/film/about-ray': 'V3',
	'/fr/film/adam-serial-lover': 'V1',
	'/fr/film/alex-et-eve': 'V2',
	'/fr/film/blindes': 'V3',
	'/fr/film/another-thin-man': 'V1',
	'/fr/film/amityville-3-d': 'V2',
	'/fr/film/atraco': 'V3',
	'/fr/film/baba-yaga-terror-of-the-dark-forest': 'V1',
	'/fr/film/battle-of-the-damned': 'V2',
	'/fr/film/a-man-of-action': 'V3',
	'/fr/film/batman-unlimited-linstinct-animal': 'V1',
	'/fr/film/appleseed-alpha': 'V2',
	'/fr/film/arsenal': 'V3',
	'/fr/film/5-enfants-et-moi': 'V1',
	'/fr/film/amazonia-lesclave-blonde': 'V2',
	'/fr/film/army-of-the-dead': 'V3',
	'/fr/film/aap-jaisa-koi': 'V1',
	'/fr/film/belles-magical-world': 'V2',
	'/fr/film/about-alex': 'V3',
	'/fr/film/best-defense': 'V1',
	'/fr/film/blackenstein': 'V2',
	'/fr/film/apres-moi-le-deluge': 'V3',
	'/fr/film/and-mrs': 'V1',
	'/fr/film/american-crime': 'V2',
	'/fr/film/aay': 'V3',
	'/fr/film/bibi-and-tina-completement-ensorcelee': 'V1',
	'/fr/film/big-legend': 'V2',
	'/fr/film/au-dela-du-silence': 'V3',
	'/fr/film/an-imperfect-murder': 'V1',
	'/fr/film/a-perdre-la-raison': 'V2',
	'/fr/film/blindman': 'V3',
	'/fr/film/apple-music-live-bjork-cornucopia': 'V1',
	'/fr/film/abandoned-2022': 'V2',
	'/fr/film/black-sunshine-baby': 'V3',
	'/fr/film/adventures-of-arsene-lupin': 'V1',
	'/fr/film/101-reykjavik': 'V2',
	'/fr/film/50-to-1': 'V3',
	'/fr/film/black-butler-book-of-the-atlantic': 'V1',
	'/fr/film/bad-25': 'V2',
	'/fr/film/365': 'V3',
	'/fr/film/austerlitz': 'V1',
	'/fr/film/bangkok-revenge': 'V2',
	'/fr/film/au-royaume-des-singes': 'V3',
	'/fr/film/american-murderer': 'V1',
	'/fr/film/belladone': 'V2',
	'/fr/film/against-the-dark': 'V3',
	'/fr/film/ask-taktikleri-2': 'V1',
	'/fr/film/ana': 'V2',
	'/fr/film/benvenuto-presidente': 'V3',
	'/fr/film/au-boulot': 'V1',
	'/fr/film/bikram-yogi-gourou-predateur': 'V2',
	'/fr/film/alpha-house': 'V3',
	'/fr/film/ames-libres': 'V1',
	'/fr/film/a-laventure': 'V2',
	'/fr/film/amityville-la-maison-des-poupees': 'V3',
	'/fr/film/5000-blankets': 'V1',
	'/fr/film/barbie-et-la-magie-de-noel': 'V2',
	'/fr/film/blackjack-1998': 'V3',
	'/fr/film/beyto': 'V1',
	'/fr/film/agatha': 'V2',
	'/fr/film/be-here-now': 'V3',
	'/fr/film/a-lego-brickumentary': 'V1',
	'/fr/film/barbie-et-ses-soeurs-a-la-recherche-des-chiots': 'V2',
	'/fr/film/blonde-sur-ordonnance': 'V3',
	'/fr/film/all-jacked-up-and-full-of-worms': 'V1',
	'/fr/film/big-gold-brick': 'V2',
	'/fr/film/altered-les-survivants': 'V3',
	'/fr/film/bank-robbers-the-last-great-heist': 'V1',
	'/fr/film/airlift': 'V2',
	'/fr/film/a-christmas-carol-2004': 'V3',
	'/fr/film/bandits-a-orgosolo': 'V1',
	'/fr/film/bigoudis-et-permanente': 'V2',
	'/fr/film/a-man-named-scott': 'V3',
	'/fr/film/bienvenue-a-bord': 'V1',
	'/fr/film/bhagam-bhag': 'V2',
	'/fr/film/a-strippers-dance': 'V3',
	'/fr/film/ashes-of-time-redux': 'V1',
	'/fr/film/blackout-2006': 'V2',
	'/fr/film/big-kill': 'V3',
	'/fr/film/a-deriva': 'V1',
	'/fr/film/azul-y-no-tan-rosa': 'V2',
	'/fr/film/ange': 'V3',
	'/fr/film/adoration': 'V1',
	'/fr/film/all-day-and-a-night': 'V2',
	'/fr/film/alpha-et-omega-2': 'V3',
	'/fr/film/age-out': 'V1',
	'/fr/film/andrea-bocelli-30-the-celebration': 'V2',
	'/fr/film/benim-dunyam': 'V3',
	'/fr/film/believe-me': 'V1',
	'/fr/film/alamo-bay': 'V2',
	'/fr/film/angammal': 'V3',
	'/fr/film/auschwitz': 'V1',
	'/fr/film/bill-burr-im-sorry-you-feel-that-way': 'V2',
	'/fr/film/beast-2021': 'V3',
	'/fr/film/american-thunder-nascar-to-le-mans': 'V1',
	'/fr/film/50-degres-fahrenheit': 'V2',
	'/fr/film/alien-weekend': 'V3',
	'/fr/film/a-bolu': 'V1',
	'/fr/film/angel-3-le-retour-dangel': 'V2',
	'/fr/film/be-my-valentine-charlie-brown': 'V3',
	'/fr/film/a-self-made-hero': 'V1',
	'/fr/film/big-boy-1966': 'V2',
	'/fr/film/bhavesh-joshi-superhero': 'V3',
	'/fr/film/anbe-sivam': 'V1',
	'/fr/film/amar-singh-chamkila': 'V2',
	'/fr/film/belle-et-sebastien-laventure-continue': 'V3',
	'/fr/film/antigone': 'V1',
	'/fr/film/all-about-e': 'V2',
	'/fr/film/bionicle-la-legende-renait': 'V3',
	'/fr/film/aileen-wuornos-the-selling-of-a-serial-killer': 'V1',
	'/fr/film/black-night': 'V2',
	'/fr/film/blackbird': 'V3',
	'/fr/film/200-metres': 'V1',
	'/fr/film/benji-la-malice': 'V2',
	'/fr/film/an-american-abroad': 'V3',
	'/fr/film/badges-of-fury': 'V1',
	'/fr/film/1up': 'V2',
	'/fr/film/barbie-heroine-de-jeu-video': 'V3',
	'/fr/film/alaska-2015': 'V1',
	'/fr/film/beautiful-darling': 'V2',
	'/fr/film/big-water-theory': 'V3',
	'/fr/film/bettie-page-reveals-all': 'V1',
	'/fr/film/amazonia': 'V2',
	'/fr/film/america-latina': 'V3',
	'/fr/film/asha-jaoar-majhe': 'V1',
	'/fr/film/always-be-my-maybe-2016': 'V2',
	'/fr/film/3-colocs-et-1-bebe': 'V3',
	'/fr/film/800-bullets': 'V1',
	'/fr/film/aventure-dans-le-grand-nord': 'V2',
	'/fr/film/beurk': 'V3',
	'/fr/film/another-you': 'V1',
	'/fr/film/27-steps-of-may': 'V2',
	'/fr/film/a-fine-mess': 'V3',
	'/fr/film/air-bud-3-world-pup': 'V1',
	'/fr/film/barbara-2017': 'V2',
	'/fr/film/7-minutes-2020': 'V3',
	'/fr/film/allez-coucher-ailleurs': 'V1',
	'/fr/film/bernard-and-doris': 'V2',
	'/fr/film/american-heart': 'V3',
	'/fr/film/bihter': 'V1',
	'/fr/film/battle-for-disclosure': 'V2',
	'/fr/film/asteroid': 'V3',
	'/fr/film/13-the-musical': 'V1',
	'/fr/film/7aum-arivu': 'V2',
	'/fr/film/beautiful-creatures': 'V3',
	'/fr/film/b-17-la-forteresse-volante': 'V1',
	'/fr/film/arturo-a-la-trentaine': 'V2',
	'/fr/film/balls-out': 'V3',
	'/fr/film/au-coeur-de-la-tourmente': 'V1',
	'/fr/film/anzio': 'V2',
	'/fr/film/armored-car-robbery': 'V3',
	'/fr/film/a-good-american': 'V1',
	'/fr/film/ancien-and-the-magic-tablet': 'V2',
	'/fr/film/arthur-malediction': 'V3',
	'/fr/film/arena-1989': 'V1',
	'/fr/film/blood-and-lace': 'V2',
	'/fr/film/better-nate-than-ever': 'V3',
	'/fr/film/bionicos': 'V1',
	'/fr/film/a-better-tomorrow': 'V2',
	'/fr/film/autonome': 'V3',
	'/fr/film/ariana-grande-excuse-me-i-love-you': 'V1',
	'/fr/film/asylum': 'V2',
	'/fr/film/beaten-to-death': 'V3',
	'/fr/film/agent-vinod': 'V1',
	'/fr/film/amerrika': 'V2',
	'/fr/film/1920': 'V3',
	'/fr/film/bhool-bhulaiyaa-2': 'V1',
	'/fr/film/all-superheroes-must-die': 'V2',
	'/fr/film/avas-impossible-things': 'V3',
	'/fr/film/blaze-1989': 'V1',
	'/fr/film/baar-baar-dekho-2016': 'V2',
	'/fr/film/belye-nochi-pochtal-ona-alekseia-triapitsyna': 'V3',
	'/fr/film/abel-1986': 'V1',
	'/fr/film/70-binladens': 'V2',
	'/fr/film/beyond-therapy': 'V3',
	'/fr/film/36-fillette': 'V1',
	'/fr/film/berlin-calling-2015': 'V2',
	'/fr/film/10-jours-pour-changer-de-vie': 'V3',
	'/fr/film/ali-baba-et-les-quarante-voleurs': 'V1',
	'/fr/film/beware-of-the-car': 'V2',
	'/fr/film/blind-1986': 'V3',
	'/fr/film/ach-du-scheisse': 'V1',
	'/fr/film/albator-84-latlantis-de-ma-jeunesse': 'V2',
	'/fr/film/bacchanales-sexuelles': 'V3',
	'/fr/film/air-martin': 'V1',
	'/fr/film/before-you-know-it': 'V2',
	'/fr/film/76-days': 'V3',
	'/fr/film/arenes-sanglantes': 'V1',
	'/fr/film/biggie-and-tupac': 'V2',
	'/fr/film/absent': 'V3',
	'/fr/film/athena-saves-christmas': 'V1',
	'/fr/film/45365': 'V2',
	'/fr/film/alone-2008': 'V3',
	'/fr/film/american-badass-a-michael-madsen-retrospective': 'V1',
	'/fr/film/anomaly-2016': 'V2',
	'/fr/film/affames': 'V3',
	'/fr/film/a-balloons-landing': 'V1',
	'/fr/film/abandon': 'V2',
	'/fr/film/alice-au-pays-des-merveilles-1933': 'V3',
	'/fr/film/batman-and-bill': 'V1',
	'/fr/film/all-this-mayhem': 'V2',
	'/fr/film/andragogy': 'V3',
	'/fr/film/arrivederci-amore-ciao': 'V1',
	'/fr/film/auntie-lees-meat-pies': 'V2',
	'/fr/film/after-blue-paradis-sale': 'V3',
	'/fr/film/10-000-dollars-for-a-massacre': 'V1',
	'/fr/film/10-days-of-a-good-man': 'V2',
	'/fr/film/affair-in-trinidad': 'V3',
	'/fr/film/3-histoires-de-lau-dela': 'V1',
	'/fr/film/ambulancen': 'V2',
	'/fr/film/arena-les-gladiateurs-de-la-mort': 'V3',
	'/fr/film/big-monster-on-campus': 'V1',
	'/fr/film/antonio-das-mortes': 'V2',
	'/fr/film/a-louest-des-rails': 'V3',
	'/fr/film/and-the-breadwinner-is': 'V1',
	'/fr/film/aayirathil-oruvan': 'V2',
	'/fr/film/batman-unlimited-mech-vs-mutants': 'V3',
	'/fr/film/bedroom-eyes': 'V1',
	'/fr/film/amazing-journey-the-story-of-the-who': 'V2',
	'/fr/film/balto-3-sur-laile-du-vent': 'V3',
	'/fr/film/avengers-grimm-time-wars': 'V1',
	'/fr/film/24-city': 'V2',
	'/fr/film/barbie-un-merveilleux-noel': 'V3',
	'/fr/film/best-night-ever': 'V1',
	'/fr/film/baian-the-assassin-m-d-part-2': 'V2',
	'/fr/film/asphalte': 'V3',
	'/fr/film/blackadders-christmas-carol': 'V1',
	'/fr/film/accidental-courtesy-daryl-davis-race-and-america': 'V2',
	'/fr/film/appelez-moi-bruce': 'V3',
	'/fr/film/awaken-2013': 'V1',
	'/fr/film/au-dela-des-grilles': 'V2',
	'/fr/film/2012-ice-age': 'V3',
	'/fr/film/banlieue-interdite': 'V1',
	'/fr/film/a-clockwork-shining-kubricks-odyssey-3': 'V2',
	'/fr/film/404-error-not-found': 'V3',
	'/fr/film/ash-wednesday-le-mercredi-des-cendres': 'V1',
	'/fr/film/blank-narcissus-passion-of-the-swamp': 'V2',
	'/fr/film/aurora-teagarden-un-frisson-dans-la-nuit': 'V3',
	'/fr/film/autobiografia-di-una-borsetta': 'V1',
	'/fr/film/10-000-km': 'V2',
	'/fr/film/bandolero': 'V3',
	'/fr/film/archangel': 'V1',
	'/fr/film/beyond-valkyrie-dawn-of-the-4th-reich': 'V2',
	'/fr/film/animal-world': 'V3',
	'/fr/film/adonis': 'V1',
	'/fr/film/back-of-the-net': 'V2',
	'/fr/film/assaut-sur-lunite-33': 'V3',
	'/fr/film/2012-la-prophetie': 'V1',
	'/fr/film/assaut-sur-la-ville': 'V2',
	'/fr/film/bare-witness': 'V3',
	'/fr/film/a-trois-on-y-va': 'V1',
	'/fr/film/american-girls-6-confrontation-mondiale': 'V2',
	'/fr/film/apache-bleibt-gleich': 'V3',
	'/fr/film/14-cameras': 'V1',
	'/fr/film/birdemic-2-the-resurrection': 'V2',
	'/fr/film/autoroute-racer': 'V3',
	'/fr/film/90-bpm': 'V1',
	'/fr/film/au-bord-de-la-mer-bleue': 'V2',
	'/fr/film/adrenochrome': 'V3',
	'/fr/film/baby-ruby': 'V1',
	'/fr/film/angels-hard-as-they-come': 'V2',
	'/fr/film/a-labordage-1952': 'V3',
	'/fr/film/8-rue-de-lhumanite': 'V1',
	'/fr/film/best-christmas-ever': 'V2',
	'/fr/film/aya-de-yopougon': 'V3',
	'/fr/film/aga': 'V1',
	'/fr/film/7-nights-of-darkness': 'V2',
	'/fr/film/16-ans-ou-presque': 'V3',
	'/fr/film/american-tragedy': 'V1',
	'/fr/film/blackmail-boys': 'V2',
	'/fr/film/american-night': 'V3',
	'/fr/film/arctic-armageddon': 'V1',
	'/fr/film/9-deaths-of-the-ninja': 'V2',
	'/fr/film/a-faith-under-siege': 'V3',
	'/fr/film/antonio-machado-los-dias-azules': 'V1',
	'/fr/film/astronaut-the-last-push': 'V2',
	'/fr/film/amateur-night': 'V3',
	'/fr/film/accident-2009': 'V1',
	'/fr/film/barneys-great-adventure': 'V2',
	'/fr/film/bis-repetita': 'V3',
	'/fr/film/all-i-want-for-christmas': 'V1',
	'/fr/film/armageddon-de-glace': 'V2',
	'/fr/film/baagbaan': 'V3',
	'/fr/film/amour-versus-glamour': 'V1',
	'/fr/film/battle-force-unite-speciale': 'V2',
	'/fr/film/battered-flesh': 'V3',
	'/fr/film/a-story-of-yonosuke': 'V1',
	'/fr/film/baby-done': 'V2',
	'/fr/film/american-refugee': 'V3',
	'/fr/film/12-jours': 'V1',
	'/fr/film/16-ans': 'V2',
	'/fr/film/a-month-by-the-lake': 'V3',
	'/fr/film/32-weeks': 'V1',
	'/fr/film/black-cadillac': 'V2',
	'/fr/film/alexandras-project': 'V3',
	'/fr/film/bikini-valley-car-wash': 'V1',
	'/fr/film/5th-ave-girl': 'V2',
	'/fr/film/a-chacun-ses-peurs': 'V3',
	'/fr/film/being-george-clooney': 'V1',
	'/fr/film/august-2011-1': 'V2',
	'/fr/film/asphalt-burning': 'V3',
	'/fr/film/battlefield-fall-of-the-world': 'V1',
	'/fr/film/acasa-ladieu-au-fleuve': 'V2',
	'/fr/film/ajeeb-daastaans': 'V3',
	'/fr/film/amoureux-pour-toujours': 'V1',
	'/fr/film/beautiful-losers': 'V2',
	'/fr/film/band-of-robbers': 'V3',
	'/fr/film/avicii-my-last-show': 'V1',
	'/fr/film/benjamin-lelephant': 'V2',
	'/fr/film/assault-in-the-ring': 'V3',
	'/fr/film/bhoomi': 'V1',
	'/fr/film/avant-laube': 'V2',
	'/fr/film/bane': 'V3',
	'/fr/film/balagam': 'V1',
	'/fr/film/atoll-k': 'V2',
	'/fr/film/atlantis-2020': 'V3',
	'/fr/film/barbie-aventure-dans-les-etoiles': 'V1',
	'/fr/film/a-labordage': 'V2',
	'/fr/film/american-nudist': 'V3',
	'/fr/film/a-la-table-des-kapoor': 'V1',
	'/fr/film/a-man-a-horse-a-gun': 'V2',
	'/fr/film/antboy-3': 'V3',
	'/fr/film/alien-outbreak': 'V1',
	'/fr/film/as-you-like-it-2017': 'V2',
	'/fr/film/alligator-2-the-mutation': 'V3',
	'/fr/film/animals-2021': 'V1',
	'/fr/film/bixler-valley-enquete-au-lycee': 'V2',
	'/fr/film/apprentice': 'V3',
	'/fr/film/au-revoir-2024': 'V1',
	'/fr/film/bigfoot-2012': 'V2',
	'/fr/film/alexander-babu-alex-in-wonderland': 'V3',
	'/fr/film/bizans-oyunlari': 'V1',
	'/fr/film/aaina': 'V2',
	'/fr/film/ayyppnn-koossiyn': 'V3',
	'/fr/film/amoureux-juste-pour-lete': 'V1',
	'/fr/film/american-translation': 'V2',
	'/fr/film/beauty-in-the-broken': 'V3',
	'/fr/film/billy-graham-an-extraordinary-journey': 'V1',
	'/fr/film/another-wolfcop': 'V2',
	'/fr/film/american-son': 'V3',
	'/fr/film/a-novel-noel': 'V1',
	'/fr/film/barbie-epic-road-trip': 'V2',
	'/fr/film/at-the-end-of-the-day': 'V3',
	'/fr/film/a-haunting-at-the-rectory': 'V1',
	'/fr/film/amar-akbar-and-tony': 'V2',
	'/fr/film/aurora-2019': 'V3',
	'/fr/film/7-minuti': 'V1',
	'/fr/film/adios-texas': 'V2',
	'/fr/film/alpha-et-omega-4-la-legende-de-la-caverne-hantee': 'V3',
	'/fr/film/a-song-for-imogene': 'V1',
	'/fr/film/aurora-teagarden-5-affaire-secrete': 'V2',
	'/fr/film/baazaar': 'V3',
	'/fr/film/bert-kreischer-lucky': 'V1',
	'/fr/film/21-years-richard-linklater': 'V2',
	'/fr/film/amai-muchi': 'V3',
	'/fr/film/believer-2': 'V1',
	'/fr/film/allure': 'V2',
	'/fr/film/amere-victoire': 'V3',
	'/fr/film/beauty-and-the-beast-1987': 'V1',
	'/fr/film/babymakers': 'V2',
	'/fr/film/6-headed-shark-attack': 'V3',
	'/fr/film/3-turken-und-ein-baby': 'V1',
	'/fr/film/abby-singer-songwriter': 'V2',
	'/fr/film/bleach-the-diamonddust-rebellion': 'V3',
	'/fr/film/angelas-christmas': 'V1',
	'/fr/film/anna-nicole': 'V2',
	'/fr/film/au-dela-du-missouri': 'V3',
	'/fr/film/assault-of-the-party-nerds-2': 'V1',
	'/fr/film/bholaa-shankar': 'V2',
	'/fr/film/big-shot': 'V3',
	'/fr/film/advanced-chemistry': 'V1',
	'/fr/film/bela-lugosi-meets-a-brooklyn-gorilla': 'V2',
	'/fr/film/a-death-in-the-gunj': 'V3',
	'/fr/film/alam': 'V1',
	'/fr/film/angel-of-nanjing': 'V2',
	'/fr/film/all-that-i-am': 'V3',
	'/fr/film/blame-2021': 'V1',
	'/fr/film/a-son-image': 'V2',
	'/fr/film/a-noel-mon-prince-viendra-2': 'V3',
	'/fr/film/bill-burr-you-people-are-all-the-same': 'V1',
	'/fr/film/alone-for-christmas': 'V2',
	'/fr/film/aurore-teagarden-10-mysteres-en-serie': 'V3',
	'/fr/film/anna-karenina': 'V1',
	'/fr/film/american-hero-2015': 'V2',
	'/fr/film/almighty-thor': 'V3',
	'/fr/film/bienvenue-chez-les-casagrandes-le-film': 'V1',
	'/fr/film/au-bonheur-des-ogres': 'V2',
	'/fr/film/a-paralyzing-redemption': 'V3',
	'/fr/film/any-de-gracia': 'V1',
	'/fr/film/24-hours-with-gaspar': 'V2',
	'/fr/film/aarambham': 'V3',
	'/fr/film/berlin-express': 'V1',
	'/fr/film/ben-stokes-phoenix-from-the-ashes': 'V2',
	'/fr/film/ali-wong-don-wong': 'V3',
	'/fr/film/bizarre-2015': 'V1',
	'/fr/film/black-butler': 'V2',
	'/fr/film/bataille-au-dela-du-soleil': 'V3',
	'/fr/film/3-coeurs': 'V1',
	'/fr/film/aiden': 'V2',
	'/fr/film/angel-flight-the-movie': 'V3',
	'/fr/film/blood-of-draculas-castle': 'V1',
	'/fr/film/amour-rime-avec-toujours': 'V2',
	'/fr/film/7-minutes': 'V3',
	'/fr/film/amoz-alexander': 'V1',
	'/fr/film/aruvi': 'V2',
	'/fr/film/among-ravens': 'V3',
	'/fr/film/au-pays-des-etoiles': 'V1',
	'/fr/film/arizona-colt': 'V2',
	'/fr/film/baratometrajes-2-0': 'V3',
	'/fr/film/adrianne-et-the-castle': 'V1',
	'/fr/film/a-plein-gaz': 'V2',
	'/fr/film/4-for-texas': 'V3',
	'/fr/film/41': 'V1',
	'/fr/film/betrayed-by-innocence': 'V2',
	'/fr/film/alleen-eline': 'V3',
	'/fr/film/ali-baba-ve-7-cuceler': 'V1',
	'/fr/film/alexandre-astier-lexoconference': 'V2',
	'/fr/film/avatar-creating-the-world-of-pandora': 'V3',
	'/fr/film/as-seen-by-the-rest': 'V1',
	'/fr/film/a-voyage-to-arcturus': 'V2',
	'/fr/film/big-bad-mama-ii': 'V3',
	'/fr/film/blood-of-redemption': 'V1',
	'/fr/film/blonde-ambition': 'V2',
	'/fr/film/a-storybots-christmas': 'V3',
	'/fr/film/a-noel-mon-prince-viendra': 'V1',
	'/fr/film/angst-2022': 'V2',
	'/fr/film/au-coeur-du-grand-canyon': 'V3',
	'/fr/film/an-elephant-can-be-extremely-deceptive': 'V1',
	'/fr/film/angels-sing': 'V2',
	'/fr/film/big-city-greens-the-movie-spacecation': 'V3',
	'/fr/film/ak-vs-ak': 'V1',
	'/fr/film/barn-of-the-naked-dead': 'V2',
	'/fr/film/aiyyaa': 'V3',
	'/fr/film/behemoth-la-creature-du-volcan': 'V1',
	'/fr/film/assassins-bullet': 'V2',
	'/fr/film/alerte-collision': 'V3',
	'/fr/film/benjamin-smoke': 'V1',
	'/fr/film/alpha-the-right-to-kill': 'V2',
	'/fr/film/anna-1987': 'V3',
	'/fr/film/7-below': 'V1',
	'/fr/film/black-november': 'V2',
	'/fr/film/azotes-de-barrio': 'V3',
	'/fr/film/batla-house': 'V1',
	'/fr/film/au-coeur-de-notre-amour': 'V2',
	'/fr/film/a-warning-to-the-curious': 'V3',
	'/fr/film/arinthum-ariyamalum': 'V1',
	'/fr/film/anthem-2023': 'V2',
	'/fr/film/bandits-1997': 'V3',
	'/fr/film/alki-alki': 'V1',
	'/fr/film/au-coeur-de-la-tornade': 'V2',
	'/fr/film/better-off-single': 'V3',
	'/fr/film/au-feu': 'V1',
	'/fr/film/bertie-and-elizabeth': 'V2',
	'/fr/film/alexander-the-last': 'V3',
	'/fr/film/ai-nu-esclave-de-lamour': 'V1',
	'/fr/film/anina': 'V2',
	'/fr/film/3-1-2-minutes-10-bullets': 'V3',
	'/fr/film/against-a-crooked-sky': 'V1',
	'/fr/film/2nd-miracle-in-cell-no-7': 'V2',
	'/fr/film/a-tokeletes-gyilkos': 'V3',
	'/fr/film/a-fools-world': 'V1',
	'/fr/film/all-in-good-fun': 'V2',
	'/fr/film/a-la-joie': 'V3',
	'/fr/film/avant-que-les-flammes-ne-seteignent': 'V1',
	'/fr/film/american-teen': 'V2',
	'/fr/film/7-19': 'V3',
	'/fr/film/ali-and-cavett-the-tale-of-the-tapes': 'V1',
	'/fr/film/baby-snakes': 'V2',
	'/fr/film/almamula': 'V3',
	'/fr/film/bienvenue-au-club': 'V1',
	'/fr/film/a-film-unfinished': 'V2',
	'/fr/film/a-loud-house-christmas': 'V3',
	'/fr/film/apple-cider-vinegar': 'V1',
	'/fr/film/1945-end-of-war': 'V2',
	'/fr/film/avant-la-vie-apres-la-mort': 'V3',
	'/fr/film/alerte-aux-marines': 'V1',
	'/fr/film/berlin-le-mysterieux-crash-davril-1945': 'V2',
	'/fr/film/aachi-et-ssipak': 'V3',
	'/fr/film/atlantics': 'V1',
	'/fr/film/a-fleur-deau': 'V2',
	'/fr/film/all-the-kind-strangers': 'V3',
	'/fr/film/anycaannn': 'V1',
	'/fr/film/a-la-recherche-du-tombeau-dalexandre-le-grand': 'V2',
	'/fr/film/a-short-story-2022': 'V3',
	'/fr/film/berlin-berlin-pour-lamour-de-lola': 'V1',
	'/fr/film/battle': 'V2',
	'/fr/film/bewitched': 'V3',
	'/fr/film/billa-2009': 'V1',
	'/fr/film/a-spanking-in-paradise': 'V2',
	'/fr/film/bitcoin-the-end-of-money-as-we-know-it': 'V3',
	'/fr/film/bezness-as-usual': 'V1',
	'/fr/film/black-cat': 'V2',
	'/fr/film/a-lancienne': 'V3',
	'/fr/film/best-supporting-actors': 'V1',
	'/fr/film/all-about-bob': 'V2',
	'/fr/film/apprenti-papa': 'V3',
	'/fr/film/bhadra-2005': 'V1',
	'/fr/film/alls-well-that-ends-well': 'V2',
	'/fr/film/black-veil-brides-alive-and-burning': 'V3',
	'/fr/film/as-it-is-in-heaven-2014': 'V1',
	'/fr/film/bde': 'V2',
	'/fr/film/belly-of-the-bulldog': 'V3',
	'/fr/film/babes-on-broadway': 'V1',
	'/fr/film/amigo-mon-colt-a-deux-mots-a-te-dire': 'V2',
	'/fr/film/actually-iconic-richard-estes': 'V3',
	'/fr/film/bin-laden-mission-minute-by-minute': 'V1',
	'/fr/film/blackbeard-the-pirate': 'V2',
	'/fr/film/a-really-haunted-loud-house': 'V3',
	'/fr/film/a-soldiers-revenge': 'V1',
	'/fr/film/anna-lucasta': 'V2',
	'/fr/film/barbie-et-chelsea-lanniversaire-perdu': 'V3',
	'/fr/film/a-choo': 'V1',
	'/fr/film/assassin-s': 'V2',
	'/fr/film/apocalypse-earth': 'V3',
	'/fr/film/adresse-inconnue': 'V1',
	'/fr/film/bling': 'V2',
	'/fr/film/72h-pour-survivre': 'V3',
	'/fr/film/83-hours-til-dawn': 'V1',
	'/fr/film/a-sweet-sickness': 'V2',
	'/fr/film/au-milieu-de-la-nuit': 'V3',
	'/fr/film/1001-gram': 'V1',
	'/fr/film/avec-django-ca-va-saigner': 'V2',
	'/fr/film/a-heros-journey-the-making-of-percy-jackson-and-the-olympians': 'V3',
	'/fr/film/5-danses': 'V1',
	'/fr/film/after-you': 'V2',
	'/fr/film/barbes-little-algerie': 'V3',
	'/fr/film/5-maitres-de-shaolin': 'V1',
	'/fr/film/actrices': 'V2',
	'/fr/film/bait-2015': 'V3',
	'/fr/film/aimes-tu-la-glace-au-brocoli-et-dautres-chansons-pour-enfants-super-simple-songs': 'V1',
	'/fr/film/a-litany-for-survival-the-life-and-work-of-audre-lorde': 'V2',
	'/fr/film/a-box-of-faith': 'V3',
	'/fr/film/blippis-big-dino-adventure': 'V1',
	'/fr/film/angele': 'V2',
	'/fr/film/bergers-en-famille': 'V3',
	'/fr/film/3-minutes': 'V1',
	'/fr/film/a-la-recherche-de-mon-ange-gardien': 'V2',
	'/fr/film/5-seconds-of-summer-the-feeling-of-falling-upwards-live-from-royal-albert-hall': 'V3',
	'/fr/film/36-vues-du-pic-saint-loup': 'V1',
	'/fr/film/a-sunday-affair': 'V2',
	'/fr/film/and-juliet': 'V3',
	'/fr/film/bio-zombie': 'V1',
	'/fr/film/abba-50-years-since-eurovision': 'V2',
	'/fr/film/11-minutes': 'V3',
	'/fr/film/au-dela-du-desir-1972': 'V1',
	'/fr/film/a-noel-mon-prince-viendra-3': 'V2',
	'/fr/film/26-years': 'V3',
	'/fr/film/arctic-tale': 'V1',
	'/fr/film/blind-husbands': 'V2',
	'/fr/film/a-alma-de-um-ciclista': 'V3',
	'/fr/film/battle-for-skyark': 'V1',
	'/fr/film/baobhan-sith': 'V2',
	'/fr/film/bayou-caviar': 'V3',
	'/fr/film/beaumarchais-linsolent': 'V1',
	'/fr/film/biswa-kalyan-rath-biswa-mast-aadmi': 'V2',
	'/fr/film/a-miracle': 'V3',
	'/fr/film/black-beach': 'V1',
	'/fr/film/another-kind-of-wedding': 'V2',
	'/fr/film/before-we-forget': 'V3',
	'/fr/film/behind-office-doors': 'V1',
	'/fr/film/becoming-mike-nichols': 'V2',
	'/fr/film/bizutage-mortel': 'V3',
	'/fr/film/a-touch-of-sweden': 'V1',
	'/fr/film/arcadia-2012': 'V2',
	'/fr/film/accidental-incest': 'V3',
	'/fr/film/a-dog-barking-at-the-moon': 'V1',
	'/fr/film/akasamantha': 'V2',
	'/fr/film/black-gestapo': 'V3',
	'/fr/film/al-hayba': 'V1',
	'/fr/film/billy-wilder-confessions': 'V2',
	'/fr/film/ames-sensibles': 'V3',
	'/fr/film/apache-warrior': 'V1',
	'/fr/film/alle-jahre-wieder': 'V2',
	'/fr/film/best-f-r-iends-volume-2': 'V3',
	'/fr/film/amy-george': 'V1',
	'/fr/film/antoine-and-antoinette': 'V2',
	'/fr/film/b-girl-rhapsody': 'V3',
	'/fr/film/alien-warfare': 'V1',
	'/fr/film/assistance-mortelle': 'V2',
	'/fr/film/allende-mi-abuelo-allende': 'V3',
	'/fr/film/black-beauty-breed': 'V1',
	'/fr/film/austin-found': 'V2',
	'/fr/film/a-raunchy-christmas-story': 'V3',
	'/fr/film/aliens-inside-us': 'V1',
	'/fr/film/alkhallat': 'V2',
	'/fr/film/ankur-arora-murder-case': 'V3',
	'/fr/film/1871-grand-jeu-imperial-a-versailles': 'V1',
	'/fr/film/beatdown': 'V2',
	'/fr/film/bella-vita': 'V3',
	'/fr/film/a-touch-of-vengeance': 'V1',
	'/fr/film/alerte-rouge-le-making-of': 'V2',
	'/fr/film/american-hangman': 'V3',
	'/fr/film/an-all-dogs-christmas-carol': 'V1',
	'/fr/film/anonymous-616': 'V2',
	'/fr/film/black-ruby': 'V3',
	'/fr/film/bellbottom': 'V1',
	'/fr/film/audition-tape-13': 'V2',
	'/fr/film/b-f-f': 'V3',
	'/fr/film/a-chorus-of-disapproval': 'V1',
	'/fr/film/a-christmas-carol-1977': 'V2',
	'/fr/film/a-life-at-stake': 'V3',
	'/fr/film/armstrong-dark-secrets': 'V1',
	'/fr/film/ankahee': 'V2',
	'/fr/film/alyah': 'V3',
	'/fr/film/a-girls-own-story': 'V1',
	'/fr/film/agent-destructeur': 'V2',
	'/fr/film/all-small-bodies': 'V3',
	'/fr/film/black-magic-rites': 'V1',
	'/fr/film/bad-hair-2019': 'V2',
	'/fr/film/biohack-yourself-lifespanning-our-vitality': 'V3',
	'/fr/film/afghanistans-opium-trail': 'V1',
	'/fr/film/amigos-2023': 'V2',
	'/fr/film/await-the-dawn': 'V3',
	'/fr/film/benda-bilili': 'V1',
	'/fr/film/assault': 'V2',
	'/fr/film/atunwa': 'V3',
	'/fr/film/art-heist': 'V1',
	'/fr/film/2001-the-making-of-a-myth': 'V2',
	'/fr/film/ben-hur-2003': 'V3',
	'/fr/film/azeem-banatwalla-problems': 'V1',
	'/fr/film/bernie-the-dolphin': 'V2',
	'/fr/film/appelkriget': 'V3',
	'/fr/film/arlette': 'V1',
	'/fr/film/belle-maman': 'V2',
	'/fr/film/apartment-12': 'V3',
	'/fr/film/all-is-calm-the-christmas-truce-of-1914': 'V1',
	'/fr/film/a-14-ans': 'V2',
	'/fr/film/6-hours-away': 'V3',
	'/fr/film/apple-music-live-peso-pluma': 'V1',
	'/fr/film/angel-2024': 'V2',
	'/fr/film/behind-the-mist': 'V3',
	'/fr/film/against-the-night': 'V1',
	'/fr/film/antoine-de-caunes-la-vie-revee-dun-enfant-du-rock': 'V2',
	'/fr/film/a-map-of-the-world-in-time': 'V3',
	'/fr/film/asteroid-a-geddon': 'V1',
	'/fr/film/93-rue-lauriston': 'V2',
	'/fr/film/bang-dream-episode-of-roselia-i-promise': 'V3',
	'/fr/film/beast-of-two-worlds-ajakaju': 'V1',
	'/fr/film/aristocrats': 'V2',
	'/fr/film/back-to-bosnia': 'V3',
	'/fr/film/before-the-streets': 'V1',
	'/fr/film/aranmanai-4': 'V2',
	'/fr/film/blind-shaft': 'V3',
	'/fr/film/al-sur-de-la-inocencia': 'V1',
	'/fr/film/altitudes': 'V2',
	'/fr/film/an-englishman-in-new-york': 'V3',
	'/fr/film/2-weeks-in-lagos': 'V1',
	'/fr/film/beaux-parents': 'V2',
	'/fr/film/betelnut-beauty': 'V3',
	'/fr/film/ash-man': 'V1',
	'/fr/film/atee-knnkll': 'V2',
	'/fr/film/belles-blondes-et-bronzees': 'V3',
	'/fr/film/a-city-haunted': 'V1',
	'/fr/film/a-woman-like-me': 'V2',
	'/fr/film/arrhythmia': 'V3',
	'/fr/film/aliens-in-egypt': 'V1',
	'/fr/film/alexandria-the-greatest-city': 'V2',
	'/fr/film/bae-wolf': 'V3',
	'/fr/film/a-rogue-in-londinium': 'V1',
	'/fr/film/billi-and-theodore': 'V2',
	'/fr/film/ange-et-gabrielle': 'V3',
	'/fr/film/beeswax': 'V1',
	'/fr/film/an-american-ballet-story': 'V2',
	'/fr/film/basanta-bilap': 'V3',
	'/fr/film/anuraga-karikkin-vellam': 'V1',
	'/fr/film/adidas-away-days': 'V2',
	'/fr/film/a-cidade-do-futuro': 'V3',
	'/fr/film/another-one-opens': 'V1',
	'/fr/film/ailecek-saskiniz': 'V2',
	'/fr/film/21-87': 'V3',
	'/fr/film/avatar-purusha': 'V1',
	'/fr/film/android-apocalypse': 'V2',
	'/fr/film/beached-tuna': 'V3',
	'/fr/film/art-of-the-game-ukiyo-e-heroes': 'V1',
	'/fr/film/as-you-like-it-2010': 'V2',
	'/fr/film/a-dogs-life-1950': 'V3',
	'/fr/film/7-cities': 'V1',
	'/fr/film/a-winding-road-a-ramble-with-richard-thompson': 'V2',
	'/fr/film/alien-encounters-roswell': 'V3',
	'/fr/film/alone-2021': 'V1',
	'/fr/film/amias': 'V2',
	'/fr/film/arras-scotlands-forgotten-battle': 'V3',
	'/fr/film/bandb-mortel': 'V1',
	'/fr/film/a-family': 'V2',
	'/fr/film/14-days': 'V3',
	'/fr/film/aqui-me-quedo': 'V1',
	'/fr/film/aladin': 'V2',
	'/fr/film/angle-mort': 'V3',
	'/fr/film/ae-watan-mere-watan': 'V1',
	'/fr/film/aeblet-and-ormen': 'V2',
	'/fr/film/ariyippu': 'V3',
	'/fr/film/bill-maher-the-decider': 'V1',
	'/fr/film/au-debut': 'V2',
	'/fr/film/alex-pandian': 'V3',
	'/fr/film/baaj-ii': 'V1',
	'/fr/film/another-harvest-moon': 'V2',
	'/fr/film/being-keegan': 'V3',
	'/fr/film/before-i-sleep': 'V1',
	'/fr/film/ankhiyon-ke-jharokhon-se': 'V2',
	'/fr/film/beer-is-cheaper-than-therapy': 'V3',
	'/fr/film/antariksham-9000-kmph': 'V1',
	'/fr/film/black-santa': 'V2',
	'/fr/film/beau-fixe': 'V3',
	'/fr/film/alisa-in-warland': 'V1',
	'/fr/film/bernie-le-dauphin-mission-sauvetage': 'V2',
	'/fr/film/411': 'V3',
	'/fr/film/a-safe-place': 'V1',
	'/fr/film/a-walnut-tree': 'V2',
	'/fr/film/adele-homecoming': 'V3',
	'/fr/film/alias': 'V1',
	'/fr/film/america-venim': 'V2',
	'/fr/film/bachi': 'V3',
	'/fr/film/bande-originale-dune-revolution': 'V1',
	'/fr/film/banksy-le-bataclan-et-la-jeune-fille-triste': 'V2',
	'/fr/film/3-2018': 'V3',
	'/fr/film/a-tale-of-love': 'V1',
	'/fr/film/bad-jim': 'V2',
	'/fr/film/all-that-glitters': 'V3',
	'/fr/film/arabski-sekret': 'V1',
	'/fr/film/blame-game': 'V2',
	'/fr/film/black-white-et-blue': 'V3',
	'/fr/film/battle-at-versailles': 'V1',
	'/fr/film/b-r-i': 'V2',
	'/fr/film/blind-vaysha': 'V3',
	'/fr/film/ashiap-man': 'V1',
	'/fr/film/akkenam': 'V2',
	'/fr/film/b-a-s-h': 'V3',
	'/fr/film/a-bientot-jespere': 'V1',
	'/fr/film/a-house-divided': 'V2',
	'/fr/film/a-love-you': 'V3',
	'/fr/film/alekto': 'V1',
	'/fr/film/big-five': 'V2',
	'/fr/film/bad-nun-deadly-vows': 'V3',
	'/fr/film/assassinee': 'V1',
	'/fr/film/18-shaolin-riders': 'V2',
	'/fr/film/40-days-at-base-camp': 'V3',
	'/fr/film/among-the-believers': 'V1',
	'/fr/film/aux-portes-de-lenfer': 'V2',
	'/fr/film/be-good-or-be-gone': 'V3',
	'/fr/film/bewaffa-se-waffa': 'V1',
	'/fr/film/bi-an-nohutari': 'V2',
	'/fr/film/bipasha': 'V3',
	'/fr/film/birthright': 'V1',
	'/fr/film/blaise-pascal': 'V2',
	'/fr/film/blood-mountain': 'V3',
};

export default metaDescriptionVariantTitles;
